import { SurveyService } from './../../services/survey.service';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, HostListener, OnInit, ViewChild, ViewContainerRef, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray, FormControl, } from '@angular/forms';
import { ApiService } from '../../api.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { GlobalServices } from '../../global.services';
import { Location } from '@angular/common';
import { GraphService } from 'src/app/services/graph.service';
import { AuthService } from 'src/app/services/auth.service';
declare var gapi: any;
var self;
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { baseUrls } from 'src/app/appConstant';
import { SubscriptionPlanService } from 'src/app/services/subscription-plan.service';
import { ToastrService } from 'ngx-toastr';

var qs = require('querystring');
declare var $: any;

@Component({
  selector: 'app-subscription-signup',
  templateUrl: './subscription-signup.component.html',
  styleUrls: ['./subscription-signup.component.scss'],
})
export class SubscriptionSignupComponent implements OnInit {

  hostedUrl = baseUrls.hostedUrl;

  mode = 'indeterminate';
  paymentcard: FormGroup;
  public isSubmiited: boolean = false;
  public submiited: boolean = false;
  public tz = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone
    ? Intl.DateTimeFormat()?.resolvedOptions()?.timeZone
    : 'America/New_York';
  public responseMessage: string = '';
  public showAlert: boolean = false;
  showAlert2: boolean = false;
  public responseMessage2: string = '';
  public issave: boolean = true;
  public errorMessage: string = '';
  public payData: object = {};
  public lastName: string = '';
  public firstName: string = '';
  public email: string = '';
  public corporateCoupon: string = '';
  public subcorporateCoupon: string = ''
  public isCouponValid: boolean = true;
  public ageGroup = '';
  public ageGroupforBransn = '';
  public ageGroupforNature = '';
  public ageGroupforHollywood = '';
  discountForm: FormGroup;
  brnsnForm: FormGroup;
  natureDrsForm: FormGroup;
  managedHealthForm: FormGroup;
  hollywoodForm: FormGroup;
  submittedBrnsn: boolean = false;
  submittedDiscount: boolean = false;
  submittedNature: boolean = false;
  submittedManagedHealth: boolean = false;
  submittedHollywood: boolean = false;
  public showMiddleSection: boolean = false;
  public year = ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'];
  public month = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12',];
  public countryList: any = [];
  public statusSignup: number = 1;
  public country = ""
  public state = ""
  public city = ""

  public countryforBransn = ""
  public stateforBransn = ""
  public cityforBransn = ""

  public countryforNature = ""
  public stateforNature = ""
  public cityforNature = ""

  public countryforHollywood = ""
  public stateforHollywood = ""
  public cityforHollywood = ""


  public discountMatchPassword: boolean = false;

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.showThirdStep) {
      this.newMiddleSection = true;
      event.stopPropagation();
    }
  }
  constructor(
    public fb: FormBuilder,
    public location: Location,
    public apiService: ApiService,
    public route: ActivatedRoute,
    public router: Router,
    public globalServices: GlobalServices,
    public viewContainerRef: ViewContainerRef,
    public cfr: ComponentFactoryResolver,
    private changeDetectorRef: ChangeDetectorRef,
    private graphService: GraphService,
    private authService: AuthService,
    private httpClient: HttpClient,
    private subscriptionPlanService: SubscriptionPlanService,
    private surveyService: SurveyService,
    private toastr: ToastrService
  ) {
    self = this;
    this.paymentcard = this.fb.group({
      holdername: [null, [Validators.minLength(3), Validators.required]],
      cardno: [
        null,
        [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(20),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
      expiryYear: [null, Validators.required],
      zipcode: [
        null,
        [Validators.required, Validators.pattern('^[0-9A-Za-z]*$')],
      ],
      cvv: [
        null,
        [
          Validators.required,
          Validators.maxLength(8),
          Validators.minLength(3),
          Validators.pattern('^[0-9A-Za-z]*$'),
        ],
      ],
    });


    this.discountForm = this.fb.group({
      dfName: ['', Validators.required],
      dlName: ['', Validators.required],
      dEmail: ['', [Validators.required, Validators.email]],
      dPassword: ['', [Validators.required, Validators.minLength(6)]],
      dConfirmPassword: ['', Validators.required],
    });


    this.brnsnForm = this.fb.group({
      fName: ['', Validators.required],
      lName: ['', Validators.required],
      brnsnEmail: ['', [Validators.required, Validators.email]],
      brnsnPassword: ['', [Validators.required, Validators.minLength(6)]],
      brnsnConfirmPassword: ['', Validators.required],
      brnsnCoupon: [''],
    });

    this.natureDrsForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      natureEmail: ['', [Validators.required, Validators.email]],
      naturePassword: ['', [Validators.required, Validators.minLength(6)]],
      natureConfirmPassword: ['', Validators.required],
    });
    this.managedHealthForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      companyName: [''],
      userProfile: [''],
      parentAccountEmail: [''],
      healthEmail: ['', [Validators.required, Validators.email]],
      healthPassword: ['', [Validators.required, Validators.minLength(6)]],
      healthConfirmPassword: ['', Validators.required],
    });

    this.managedHealthForm.get('userProfile')?.valueChanges.subscribe((value) => {
      const parentAccountEmailControl = this.managedHealthForm.get('parentAccountEmail');
      if (value === 'Dependent') {
        parentAccountEmailControl?.setValidators([Validators.required, Validators.email]);
      } else {
        parentAccountEmailControl?.clearValidators();
        parentAccountEmailControl?.setValue('');
      }
      parentAccountEmailControl?.updateValueAndValidity();
    });

    this.configureManageHealthSpecificValidation(false);

    this.hollywoodForm = this.fb.group({
      hollywoodFirstName: ['', Validators.required],
      hollywoodLastName: ['', Validators.required],
      hollywoodEmail: ['', [Validators.required, Validators.email]],
      hollywoodPassword: ['', [Validators.required, Validators.minLength(6)]],
      hollywoodConfirmPassword: ['', Validators.required],
      // hollywoodCoupon: ['', Validators.required]
    });

    this.globalServices.signupTriggerForSignupPage.subscribe((val) => {
      if (val) {
        if (this.twoStepFlow) {
          if (this.uniqueKey == 'my-app') {
            this.isTrialUsed == 1
              ? (this.questionSection = false) // if user already take a free tial. So dont show questionaire section !!
              : (this.questionSection = true);
            this.thankYouSectionFlag ? (this.newMiddleSection = false) : '';
          }
          if (!this.thankYouSectionFlag) {
            this.newMiddleSection = true;
            this.showThirdStep = true;
            this.colorSecondStep = true;
          }
        } else {
          this.colorSecondStep = true;
          this.secondStepShow = true;
        }
        this.showNext = true;
        this.statusSignup = 0;
        this.moveToTop();
        this.getdata();
      } else {
        this.getdata();
      }
    });
    if (this.globalServices.isLoggedIn) {
      this.showNext = true;
      this.statusSignup = 0;
    }

    if (localStorage.getItem("userToken") != null) {
      this.router.navigate(['/alreadyloggedin']);
    }

  }
  colorFirstStep = true;
  colorSecondStep = false;
  colorThirdStep = false;
  thankYouSectionFlag = false;
  flagForDiscountPlan = false;
  userActivityLog;
  freeRoute: boolean;
  yearlyRoute: boolean = false;
  monthlyRoute: boolean = false;
  annualyRoute: boolean = false;
  ssoOption = null;
  public brnsnsMsg: string = '';
  public natureMsg: string = '';
  public healthMsg: string = '';
  public hollywoodMsg: string = '';
  public discountFormErrorMessage: string = '';
  public questionSectionforbrnsn: boolean = false;
  public questionSectionforNature: boolean = false;
  public questionSectionforManagedHealth: boolean = false;
  public questionSectionforHollywood: boolean = false;
  public isManageHealthBrand: boolean = false;
  ngOnInit(): void {
    if (this.globalServices.isBrowser) {
      this.globalServices?.hideHeader.next(true);
      this.globalServices?.hideFooter.next(false);
      setTimeout(() => {
        this.moveToTop();
      }, 1500);
      this.globalServices.headerviewcontainerhelper = this.viewContainerRef;
      this.globalServices.headercrf = this.cfr;

      const freeExist = this.router.url?.toString();
      if (this.router.url?.toString()?.includes('free') || this.router.url?.toString()?.includes('corp') || this.router.url?.toString()?.includes('b2b')) {
        this.thankYouSectionFlag = true;
        this.freeRoute = true;
      } else if (this.router.url?.toString()?.includes('yearly')) {
        this.yearlyRoute = true;
      } else {
        this.newMiddleSection = true;
      }
      if (this.router.url?.toString()?.includes('discount')) {
        this.flagForDiscountPlan = true;
        this.ssoOption = this.route.snapshot.queryParamMap.get('sso');
        // this.newMiddleSection = false;
      }
      if (this.globalServices?.isLoggedIn) {
        this.showNext = true;
        this.secondStepShow = !this.secondStepShow;
        this.colorSecondStep = true;
      }
      var isRefresh = false;
      this.searchCallSubjectForGmailContact
        .pipe(
          debounceTime(500)
        )
        .subscribe((value) => {
          this.searchGoogleGmailContacts(value);
        });
      this.initCarouselConfig();
      this.getSubscriptionPlan();
      this.getSurveyQuestion()
    }
  }


  get b() { return this.brnsnForm.controls; }
  get n() { return this.natureDrsForm.controls; }
  get m() { return this.managedHealthForm.controls; }

  configureManageHealthSpecificValidation(enable: boolean) {
    const companyNameControl = this.managedHealthForm.get('companyName');
    const userProfileControl = this.managedHealthForm.get('userProfile');
    const parentAccountEmailControl = this.managedHealthForm.get('parentAccountEmail');

    if (enable) {
      companyNameControl?.setValidators([Validators.required]);
      userProfileControl?.setValidators([Validators.required]);
      if (userProfileControl?.value === 'Dependent') {
        parentAccountEmailControl?.setValidators([Validators.required, Validators.email]);
      }
    } else {
      companyNameControl?.clearValidators();
      userProfileControl?.clearValidators();
      parentAccountEmailControl?.clearValidators();
      companyNameControl?.setValue('');
      userProfileControl?.setValue('');
      parentAccountEmailControl?.setValue('');
    }

    companyNameControl?.updateValueAndValidity();
    userProfileControl?.updateValueAndValidity();
    parentAccountEmailControl?.updateValueAndValidity();
  }
  get h() { return this.hollywoodForm.controls; }
  get d() { return this.discountForm.controls; }

  ////////////////////////////////////////Start Discount Form ///////////////////////////////////
  submitDiscountForm() {
    this.mode = 'indeterminate';
    this.submittedDiscount = true;
    if (this.discountForm.invalid) {
      this.mode = 'determinate';
      return;
    } else {
      if (this.discountForm.value.dPassword != this.discountForm.value.dConfirmPassword) {
        this.discountMatchPassword = true;
        this.mode = 'determinate';
        return
      } else {
        this.discountMatchPassword = false;
        let url = 'user/signup';
        let data: object = {
          email: this.discountForm.value.dEmail,
          firstName: this.discountForm.value.dfName,
          lastName: this.discountForm.value.dlName,
          password: this.discountForm.value.dPassword,
          conpassword: this.discountForm.value.dConfirmPassword,
        };
        data['timezone'] = this.tz ? this.tz : 'America/New_York';
        data['subscriptionType'] = 'general';
        data['type'] = '';
        data['signUpFrom'] = "free";
        this.apiService.postFormData(url, this.globalServices.toFormData(data)).subscribe(res => {
          if (res['success']) {
            if (res?.token) {
              localStorage.setItem('userToken', res?.token);
            }
            localStorage.setItem(
              'userSubscribeInfo',
              JSON.stringify({ ...data })
            );
            localStorage.setItem(
              'userEmail',
              this.discountForm.value.dEmail.toLocaleLowerCase()
            );
            localStorage.setItem('userPass', this.discountForm.value.dPassword);
            this.submitDiscountLogin(this.discountForm.value);
          } else {
            this.discountFormErrorMessage = res.message;
          }
        })
      }
    }
  }

  submitDiscountLogin(value) {
    this.mode = 'indeterminate';
    let data = {
      email: value.dEmail,
      password: value.dPassword,
      type: 'normal',
    };
    let url = 'user/login';
    this.apiService.postFormData(url, data).subscribe((res) => {
      if (res['success']) {
        this.showDiscountForm = false;
        localStorage.setItem('userToken', res['token'])
        this.globalServices.postUserActivityLog({
          loginFromUrl: "free",
        });
        localStorage.setItem(
          'userDetails',
          JSON.stringify(res['data'])
        );
        localStorage.setItem(
          'userActivityLog',
          JSON.stringify({ loginFromUrl: "free" })
        );
        this.submitTheQuestionaireforDiscount();
      }
    })
  }

  submitTheQuestionaireforDiscount() {
    this.mode = 'indeterminate';
    const obj = {
      "wellness_interest": "improving_physical;managing_stress;wellness_travel",
      "age_group_interest": "25-34",
      "city": "mumbai",
      "state": "maharastra",
      "country": "India"
    }
    this.apiService?.postuserDataWithToken('user-data', obj).subscribe(
      (resOfQuestionaire: any) => {
        this.newMiddleSection = false;
        if (resOfQuestionaire?.status) {
          // user activity log
          this.globalServices?.postUserActivityLog({
            questionaireCompleted: true,
          });
          let localStorageObj = JSON.parse(
            localStorage.getItem('userActivityLog')
          );
          localStorage.setItem(
            'userActivityLog',
            JSON.stringify({
              ...localStorageObj,
              ...{ questionaireCompleted: true },
            })
          );
          this.questionSection = false;
          setTimeout(() => {
            this.mode = 'determinate';
            this.showThirdStep = true;
            if(this.monthlyRoute){
              this.getSubscriptionDetails(
                this.planInfo?.data?._id,
                'monthly'
              );
            }
            if(this.yearlyRoute){
              this.getSubscriptionDetails(
                this.planInfo?.data?._id,
                'yearly'
              );
            }
            
          }, 100);
        } else {
          if (resOfQuestionaire?.msg == 'Account already created') {
            this.responseMessage = 'Account already created !!';
            this.showAlert = true;
          } else {
            this.responseMessage = 'Please try again !!';
            this.showAlert = true;
          }
        }
        // this.mode = 'determinate';
      },
      (error) => {
        // this.mode = 'determinate';
      }
    );

  }

  // public discountCouponCode = '';
  paymentForDiscount() {
    let data = {};
    this.mode = 'indeterminate';
    let url = 'billingservice/usersubscription/payment';
    if(this.monthlyRoute){
      data = {
        "signUpFrom": "free",
        "vid": "",
        "timezone": "Asia/Calcutta",
        "durtype": "monthly",
        "occurtype": "recursive",
        "uniqueKey": "my-app",
        "users": [],
        "isTrialUsed": 0,
        "password": this.discountForm.value.dPassword,
        "isCorpCoupon": false
      }
    }

    if(this.yearlyRoute){
      data = {
        "signUpFrom": "free",
        "vid": "",
        "timezone": "Asia/Calcutta",
        "durtype": "yearly",
        "occurtype": "recursive",
        "uniqueKey": "my-app",
        "users": [],
        "isTrialUsed": 0,
        "password": this.discountForm.value.dPassword,
        "isCorpCoupon": false
      }
    }
    this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
      (response) => {
        this.payData = response;
        if (response.status) {
          setTimeout(() => {
            localStorage.removeItem('bookingpage');
            localStorage.setItem(
              'planUserId',
              JSON.stringify({
                userId: this.payData['userId'],
              })
            );
            this.mode = 'determinate';
            this.changeDetectorRef.detectChanges();

          }, 1000);
          if (this.globalServices.isBrowser) {
            return window.location.href = response.redirectUrl;
          }

        } else {
          this.subscriberdata = JSON.parse(
            localStorage.getItem('planpayment')
          );
          this.GettotalPrice();
          this.findDiscountPrice();
          this.showAlert = true;
          this.responseMessage =
            'Sorry, we could not complete the transaction. Please try again later!';
          this.mode = 'determinate';
        }
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        this.errorMessage = 'Something went wrong!';
        setTimeout(() => {
          this.errorMessage = '';
        }, 3000);
      }
    );
  }

  //////////////////////////////////////End Discount Form ///////////////////////////////////////

  /////////////////////////////////////////// Start Form Brnsn///////////////////////////////////////////////////////

  submitBrnsn() {
    this.mode = 'indeterminate';
    this.submittedBrnsn = true;
    if (this.brnsnForm.invalid) {
      this.mode = 'determinate';
      return;
    }
    if (this.brnsnCouponCode != "" && this.isCouponValid) {
      let url = 'user/signup';
      let data = {};
      data['email'] = this.brnsnForm.value.brnsnEmail;
      data['firstName'] = this.brnsnForm.value.fName;
      data['lastName'] = this.brnsnForm.value.lName;
      data['password'] = this.brnsnForm.value.brnsnPassword;
      data['timezone'] = this.tz ? this.tz : 'America/New_York';
      data['subscriptionType'] = 'corporate';
      data['type'] = '';
      data['signUpFrom'] = "corporate";
      data['corpCoupon'] = this.corpCoupon;
      data['onBordingCoupon'] = this.brnsnCouponCode;
      this.apiService
        .postFormData(url, this.globalServices.toFormData(data))
        .subscribe(res => {
          if (res['success']) {
            if (res?.token) {
              localStorage.setItem('userToken', res?.token);
            }
            localStorage.setItem(
              'userSubscribeInfo',
              JSON.stringify({ ...data, ...{ password: this.brnsnForm.value.brnsnPassword } })
            );
            localStorage.setItem(
              'userEmail',
              this.brnsnForm.value.brnsnEmail.toLocaleLowerCase()
            );
            localStorage.setItem('userPass', this.brnsnForm.value.brnsnPassword);

            this.submitBrnsnLogin(this.brnsnForm.value);
        this.mode = 'determinate';

          } else {
            this.brnsnsMsg = res['message'];
        this.mode = 'determinate';

          }
        })
    }
  }

  submitBrnsnLogin(value) {
    this.mode = 'indeterminate';
    let data = {
      email: value.brnsnEmail,
      password: value.brnsnPassword,
      type: 'normal',
    };
    let url = 'user/login';
    this.apiService
      .postFormData(url, data)
      .subscribe((res) => {
        if (res['success']) {
          this.questionSectionforbrnsn = true;
          this.brnsn = false;
          localStorage.setItem('userToken', res['token'])
          this.globalServices.postUserActivityLog({
            loginFromUrl: "free",
          });
          localStorage.setItem(
            'userDetails',
            JSON.stringify(res['data'])
          );
          localStorage.setItem(
            'userActivityLog',
            JSON.stringify({ loginFromUrl: "free" })
          );
          this.submitTheQuestionaireforBransn();
        this.mode = 'determinate';
        }
      })
  }

  public questionAnsforBransnSelectedArray = [];
  questionSelectionChangeforBransn(event) {
    const value = event?.target?.value;
    if (value) {
      if (this.questionAnsforBransnSelectedArray?.includes(value)) {
        const index = this.questionAnsforBransnSelectedArray?.indexOf(value);
        this.questionAnsforBransnSelectedArray?.splice(index, 1);
      } else {
        this.questionAnsforBransnSelectedArray?.push(value);
      }
    }
  }

  onItemChangeforBransns(value) {
    this.ageGroupforBransn = value
  }

  public errorMessageForQuestionaireforBransn = null;
  submitTheQuestionaireforBransn() {
    this.mode = 'indeterminate';
    const obj = {
      "wellness_interest": "improving_physical;managing_stress;wellness_travel",
      "age_group_interest": "25-34",
      "city": "mumbai",
      "state": "maharastra",
      "country": "India"
    }
    this.apiService?.postuserDataWithToken('user-data', obj).subscribe(
      (res: any) => {
        if (res['status']) {
          this.errorMessageForQuestionaireforBransn = null;
          this.globalServices?.postUserActivityLog({ questionaireCompleted: true });
           this.paymentBransn(this.brnsnForm.value);
          // this.router.navigate(['/confirmation']);
        } else {
          this.errorMessageForQuestionaireforBransn = res['message'];
        }
      })
  }


  public brnsnCouponCode = '';
  paymentBransn(value) {
    this.mode = 'indeterminate';
    let url = 'billingservice/usersubscription/payment';
    let data =
    {
      "signUpFrom": "corporate",
      "vid": "",
      "timezone": "Asia/Calcutta",
      "couponCode": this.brnsnCouponCode,
      "durtype": "yearly",
      "occurtype": "recursive",
      "uniqueKey": "my-app",
      "users": [],
      "isTrialUsed": 0,
      "isCorpCoupon": true,
      "password": value.brnsnPassword
    }

    this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
      (response) => {
        this.mode = 'determinate';
        if (response && response.redirectUrl) {
          window.location.href = response.redirectUrl;
        } else {
          this.router.navigate(['/confirmation']);
        }
      },
      (error) => {
        this.mode = 'determinate';
        console.error(error);
      })
  }

  /////////////////////////////////////////////////End Form Brnsn///////////////////////////////////////////

  ////////////////////////////////////////////////Start Nature Form ///////////////////////////////////////
  submitNatureDrs() {
    this.mode = 'indeterminate';
    this.submittedNature = true;
    if (this.natureDrsForm.invalid) {
      this.mode = 'determinate';
      return;
    }
    let url = 'user/signup';
    let data = {};
    data['email'] = this.natureDrsForm.value.natureEmail;
    data['firstName'] = this.natureDrsForm.value.firstName;
    data['lastName'] = this.natureDrsForm.value.lastName;
    data['password'] = this.natureDrsForm.value.naturePassword;
    data['timezone'] = this.tz ? this.tz : 'America/New_York';
    data['subscriptionType'] = 'corporate';
    data['type'] = '';
    data['signUpFrom'] = "corporate";
    this.apiService
      .postFormData(url, this.globalServices.toFormData(data))
      .subscribe(res => {
        if (res['success']) {
          if (res?.token) {
            localStorage.setItem('userToken', res?.token);
          }
          localStorage.setItem(
            'userSubscribeInfo',
            JSON.stringify({ ...data, ...{ password: this.natureDrsForm.value.naturePassword } })
          );
          localStorage.setItem(
            'userEmail',
            this.natureDrsForm.value.natureEmail.toLocaleLowerCase()
          );
          localStorage.setItem('userPass', this.natureDrsForm.value.naturePassword);
          this.submitNatureLogin(this.natureDrsForm.value)
        } else {
          this.natureMsg = res['message'];
        }
      })
  }

  submitNatureLogin(value) {
    this.mode = 'indeterminate';
    let data = {
      email: value.natureEmail,
      password: value.naturePassword,
      type: 'normal',
    };
    let url = 'user/login';
    this.apiService
      .postFormData(url, data)
      .subscribe((res) => {
        if (res['success']) {
          this.questionSectionforNature = true;
          this.natureDrs = false;
          localStorage.setItem('userToken', res['token'])
          this.globalServices.postUserActivityLog({
            loginFromUrl: "free",
          });
          localStorage.setItem(
            'userDetails',
            JSON.stringify(res['data'])
          );
          localStorage.setItem(
            'userActivityLog',
            JSON.stringify({ loginFromUrl: "free" })
          );
          this.submitTheQuestionaireforNature();
        }

      })
  }

  public questionAnsforNatureSelectedArray = [];
  questionSelectionChangeforNature(event) {
    const value = event?.target?.value;
    if (value) {
      if (this.questionAnsforNatureSelectedArray?.includes(value)) {
        const index = this.questionAnsforNatureSelectedArray?.indexOf(value);
        this.questionAnsforNatureSelectedArray?.splice(index, 1);
      } else {
        this.questionAnsforNatureSelectedArray?.push(value);
      }
    }
  }

  onItemChangeforNature(value) {
    this.ageGroupforNature = value
  }

  public errorMessageForQuestionaireforNature = null;
  submitTheQuestionaireforNature() {
    this.mode = 'indeterminate';
    const obj = {
      "wellness_interest": "improving_physical;managing_stress;wellness_travel",
      "age_group_interest": "25-34",
      "city": "mumbai",
      "state": "maharastra",
      "country": "India"
    }
    this.apiService?.postuserDataWithToken('user-data', obj).subscribe(
      (res: any) => {
        if (res['status']) {
          this.errorMessageForQuestionaireforNature = null;
          this.globalServices?.postUserActivityLog({ questionaireCompleted: true });
          this.paymentNature(this.natureDrsForm.value);
          this.router.navigate(['/confirmation']);
        } else {
          this.errorMessageForQuestionaireforNature = res['message'];
        }
      })
  }


  paymentNature(value) {
    this.mode = 'indeterminate';
    let url = 'billingservice/usersubscription/payment';
    let data =
    {
      "signUpFrom": "corporate",
      "vid": "",
      "timezone": "Asia/Calcutta",
      "couponCode": 'NATUREDRS',
      "durtype": "yearly",
      "occurtype": "recursive",
      "uniqueKey": "my-app",
      "users": [],
      "isTrialUsed": 0,
      "isCorpCoupon": true,
      "password": value.naturePassword
    }

    this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
      (response) => {
        this.mode = 'determinate';
      })
  }
  ////////////////////////////////////////////////End Nature Form /////////////////////////////////////////

  ////////////////////////////////////////////////Start MANAGED HEALTH Form ///////////////////////////////////////
  submitManagedHealth() {
    this.mode = 'indeterminate';
    this.submittedManagedHealth = true;
    if (this.managedHealthForm.invalid) {
      this.mode = 'determinate';
      return;
    }
    let url = 'user/signup';
    let data = {};
    data['email'] = this.managedHealthForm.value.healthEmail;
    data['firstName'] = this.managedHealthForm.value.firstName;
    data['lastName'] = this.managedHealthForm.value.lastName;
    data['companyName'] = this.managedHealthForm.value.companyName;
    data['userProfile'] = this.managedHealthForm.value.userProfile;
    data['parentAccountEmail'] = this.managedHealthForm.value.userProfile === 'Dependent'
      ? this.managedHealthForm.value.parentAccountEmail
      : '';
    data['password'] = this.managedHealthForm.value.healthPassword;
    data['timezone'] = this.tz ? this.tz : 'America/New_York';
    data['subscriptionType'] = 'corporate';
    data['type'] = '';
    data['signUpFrom'] = "corporate";
    data['corpCoupon'] = this.corpCoupon;
    this.apiService
      .postFormData(url, this.globalServices.toFormData(data))
      .subscribe(res => {
        if (res['success']) {
          if (res?.token) {
            localStorage.setItem('userToken', res?.token);
          }
          localStorage.setItem(
            'userSubscribeInfo',
            JSON.stringify({ ...data, ...{ password: this.managedHealthForm.value.healthPassword } })
          );
          localStorage.setItem(
            'userEmail',
            this.managedHealthForm.value.healthEmail.toLocaleLowerCase()
          );
          localStorage.setItem('userPass', this.managedHealthForm.value.healthPassword);
          this.submitManagedHealthLogin(this.managedHealthForm.value)
        } else {
          this.mode = 'determinate';
          this.healthMsg = res['message'];
        }
      }, error => {
        this.mode = 'determinate';
        this.healthMsg = 'An error occurred during signup. Please try again.';
      })
  }

  submitManagedHealthLogin(value) {
    this.mode = 'indeterminate';
    let data = {
      email: value.healthEmail,
      password: value.healthPassword,
      type: 'normal',
    };
    let url = 'user/login';
    this.apiService
      .postFormData(url, data)
      .subscribe((res) => {
        if (res['success']) {
          this.questionSectionforManagedHealth = true;
          this.health = false;
          localStorage.setItem('userToken', res['token'])
          this.globalServices.postUserActivityLog({
            loginFromUrl: "free",
          });
          localStorage.setItem(
            'userDetails',
            JSON.stringify(res['data'])
          );
          localStorage.setItem(
            'userActivityLog',
            JSON.stringify({ loginFromUrl: "free" })
          );
          this.submitTheQuestionaireforManagedHealth();
        } else {
          this.mode = 'determinate';
        }
      }, error => {
        this.mode = 'determinate';
      })
  }

  // public questionAnsforNatureSelectedArray = [];
  // questionSelectionChangeforNature(event) {
  //   const value = event?.target?.value;
  //   if (value) {
  //     if (this.questionAnsforNatureSelectedArray?.includes(value)) {
  //       const index = this.questionAnsforNatureSelectedArray?.indexOf(value);
  //       this.questionAnsforNatureSelectedArray?.splice(index, 1);
  //     } else {
  //       this.questionAnsforNatureSelectedArray?.push(value);
  //     }
  //   }
  // }

  // onItemChangeforNature(value) {
  //   this.ageGroupforNature = value
  // }

  public errorMessageForQuestionaireforHealth = null;
  submitTheQuestionaireforManagedHealth() {
    this.mode = 'indeterminate';
    const obj = {
      "wellness_interest": "improving_physical;managing_stress;wellness_travel",
      "age_group_interest": "25-34",
      "city": "mumbai",
      "state": "maharastra",
      "country": "India"
    }
    this.apiService?.postuserDataWithToken('user-data', obj).subscribe(
      (res) => {
        if (res['status']) {
          this.errorMessageForQuestionaireforHealth = null;
          this.globalServices?.postUserActivityLog({ questionaireCompleted: true });
          this.paymentMangedHealth(this.managedHealthForm.value);
          const confirmationParams = this.corpCoupon === 'managehealth'
            ? { queryParams: { managehealth: true } }
            : {};
          this.router.navigate(['/confirmation'], confirmationParams);
        } else {
          this.mode = 'determinate';
          this.errorMessageForQuestionaireforHealth = res['message'];
        }
      }, error => {
        this.mode = 'determinate';
        this.errorMessageForQuestionaireforHealth = 'An error occurred. Please try again.';
      })
  }


  paymentMangedHealth(value) {
    this.mode = 'indeterminate';
    let url = 'billingservice/usersubscription/payment';
    
    if (!this.corpCouponCode && localStorage.getItem('corpCouponCode')) {
      this.corpCouponCode = localStorage.getItem('corpCouponCode');
    }
    
    const couponCode = this.corpCouponCode || (this.isManageHealthBrand ? 'MHEALTH' : '');
    
    let data =
    {
      "signUpFrom": "corporate",
      "vid": "",
      "timezone": "Asia/Calcutta",
      "couponCode": couponCode,
      "durtype": "yearly",
      "occurtype": "recursive",
      "uniqueKey": "my-app",
      "users": [],
      "isTrialUsed": 0,
      "isCorpCoupon": true,
      "password": value.healthPassword
    }

    this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
      (response) => {
        this.mode = 'determinate';
        localStorage.removeItem('corpCouponCode');
      },
      (error) => {
        this.mode = 'determinate';
        console.error('Payment error:', error);
      })
  }
  ////////////////////////////////////////////////End Nature Form /////////////////////////////////////////

  /////////////////////////////////////////////////Form Hollywood///////////////////////////////////////////

  submitHollywood(coupon_code:any) {
    this.mode = 'indeterminate';
    this.submittedHollywood = true;
    if (this.hollywoodForm.invalid) {
      this.mode = 'determinate';
      return;
    }
    let url = 'user/signup';
    let data = {};
    data['email'] = this.hollywoodForm.value.hollywoodEmail;
    data['firstName'] = this.hollywoodForm.value.hollywoodFirstName;
    data['lastName'] = this.hollywoodForm.value.hollywoodLastName;
    data['password'] = this.hollywoodForm.value.hollywoodPassword;
    data['timezone'] = this.tz ? this.tz : 'America/New_York';
    data['subscriptionType'] = 'corporate';
    data['type'] = '';
    data['signUpFrom'] = "corporate";
    this.apiService
      .postFormData(url, this.globalServices.toFormData(data))
      .subscribe(res => {
      this.mode = 'determinate';

        if (res['success']) {
          if (res?.token) {
            localStorage.setItem('userToken', res?.token);
          }
          localStorage.setItem(
            'userSubscribeInfo',
            JSON.stringify({ ...data, ...{ password: this.hollywoodForm.value.hollywoodPassword } })
          );
          localStorage.setItem(
            'userEmail',
            this.hollywoodForm.value.hollywoodEmail.toLocaleLowerCase()
          );
          localStorage.setItem('userPass', this.hollywoodForm.value.hollywoodPassword);
          this.questionSectionforHollywood = true;
          this.hollywood = false;
          this.submitHollywoodLogin(coupon_code);
        } else {
          this.hollywoodMsg = res['message'];
        }
      })

  }

  submitHollywoodLogin(type:any) {
    this.mode = 'indeterminate';
    let data = {
      email: this.hollywoodForm.controls.hollywoodEmail.value,
      password:this.hollywoodForm.controls.hollywoodPassword.value,
      type: 'normal',
    };
    let url = 'user/login';
    this.apiService
      .postFormData(url, data)
      .subscribe((res) => {
        localStorage.setItem('userToken', res['token'])
        this.globalServices.postUserActivityLog({
          loginFromUrl: "free",
        });
        localStorage.setItem(
          'userDetails',
          JSON.stringify(res['data'])
        );
        localStorage.setItem(
          'userActivityLog',
          JSON.stringify({ loginFromUrl: "free" })
        );
        this.submitTheQuestionaireforHollywood(type);
      })
  }

  public questionAnsforHollywoodSelectedArray = [];
  questionSelectionChangeforHollywood(event) {
    const value = event?.target?.value;
    if (value) {
      if (this.questionAnsforHollywoodSelectedArray?.includes(value)) {
        const index = this.questionAnsforHollywoodSelectedArray?.indexOf(value);
        this.questionAnsforHollywoodSelectedArray?.splice(index, 1);
      } else {
        this.questionAnsforHollywoodSelectedArray?.push(value);
      }
    }
  }

  onItemChangeforHollywood(value) {
    this.ageGroupforHollywood = value
  }

  public errorMessageForQuestionaireforHollywood = null;
  submitTheQuestionaireforHollywood(type:any) {
    this.mode = 'indeterminate';
    const obj = {
      "wellness_interest": "improving_physical;managing_stress;wellness_travel",
      "age_group_interest": "25-34",
      "city": "mumbai",
      "state": "maharastra",
      "country": "India"
    }
    this.apiService?.postuserDataWithToken('user-data', obj).subscribe(
      (res: any) => {
        if (res['status']) {
          this.errorMessageForQuestionaireforHollywood = null;
          this.globalServices?.postUserActivityLog({ questionaireCompleted: true });
          this.paymentHollywood(type);
          let parm ={};
          if(type == 'HOLLY'){
            parm['holly'] = true;
          }
          else if(type == 'FUNEVO'){
            parm['funevo'] =true;
          }
          else{
            parm['holly'] = true;
          }
          this.router.navigate(['/confirmation'],{queryParams:parm});
        } else {
          this.errorMessageForQuestionaireforHollywood = res['message'];
        }
      })
  }


  paymentHollywood(type) {
    this.mode = 'indeterminate';
    let url = 'billingservice/usersubscription/payment';
    let data =
    {
      "signUpFrom": "corporate",
      "vid": "",
      "timezone": "Asia/Calcutta",
      "couponCode":type,
      "durtype": "yearly",
      "occurtype": "recursive",
      "uniqueKey": "my-app",
      "users": [],
      "isTrialUsed": 0,
      "isCorpCoupon": true,
      "password": this.hollywoodForm.controls.hollywoodPassword.value
    }

    this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
      (response) => {
        this.mode = 'determinate';
        console.log(response);
    })
  }

  ///////////////////////////////////////////Form Hollywood///////////////////////////////////////

  public isNumberKey(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    return !(charCode > 31 && (charCode > 48 || charCode < 57));
  }

  public chekNumber(evt) {
    if (evt.which < 48 || evt.which > 57) {
      evt.preventDefault();
    }
  }

  public subscriberdata = [];
  get f() {
    return this.paymentcard.controls;
  }

  public totalPrice: number = 0;
  public GettotalPrice() {
    if (this.globalServices.isBrowser) {
      this.totalPrice = 0;
      for (let obj of this.subscriberdata) {
        this.totalPrice +=
          obj['Originalprice'] != null && obj['Originalprice'] != undefined
            ? +obj['Originalprice'].toFixed(2)
            : 0;
      }
    }
  }

  public DiscountPrice: number = 0;
  public findDiscountPrice() {
    if (this.globalServices.isBrowser) {
      this.DiscountPrice = 0;
      let discountPrice = 0;
      for (let obj of this.subscriberdata) {
        discountPrice =
          discountPrice +
          (obj['discount'] != null && obj['discount'] != undefined
            ? +obj['discount'].toFixed(2)
            : 0);
      }
      if (discountPrice == 0) {
        this.DiscountPrice = this.globalTotalPrice;
      } else {
        this.DiscountPrice = discountPrice;
      }
    }
  }
  public globalTotalPrice: any;
  public coupanData: Array<object> = [];
  public appliedCode: string = '';
  public responsePur: number;
  public originalData: Array<any> = [];
  public details_plan: Array<Object> = [];
  public showplan: string = '0';
  public _id: string;
  public type: string;
  public corpCoupon: string = undefined;
  public corpCouponCode: string = undefined;
  public corp_name: String = "App";
  public userSubscriptionResult: Object = {};
  public plan_name: string;
  planId;
  twoStepFlow = false;
  isTrial;
  uniqueKey;
  isExpired: number;
  isPromotional;
  activeFreeTrial;
  isTrialUsed;
  isPlanPurchased;
  isSubsCouponValid: boolean = true;
  public corpOlaRoute: boolean = false;
  public showDiscountForm: boolean = false;
  public b2b: boolean = false;
  public brnsn: boolean = false;
  public natureDrs: boolean = false;
  public hollywood: boolean = false;
  public funevo:boolean =false;
  public health:boolean =false;
  public getdata() {
    let type: any;
    let id: any;
    this.route.params?.subscribe((param) => {
      let par: any = param?.slug?.split('-');
      console.log("par",par);
      type = par[1];
      id = par[0];
      this.corpCoupon = par.slice(2).join('-');
      this.type = par[1];
      this._id = par[0];
      if (
        type.toLowerCase() == 'monthly' ||
        type.toLowerCase() == 'quarterly' ||
        type.toLowerCase() == 'yearly' ||
        type.toLowerCase() == 'free' ||
        type.toLowerCase() == 'discount' ||
        type.toLowerCase() == 'corp' ||
        type.toLowerCase() == 'b2b'
      ) {
      } else {
        this.router.navigate(['/']);
      }

      try {
        if (this.type == 'yearly') {
          this.getSubscriptionDetails(id, 'yearly');
          this.showNext = true;
          this.showDiscountForm = true;
          this.annualyRoute = true;
        } else {
          if (this.type == 'discount') {
            this.getSubscriptionDetails(id, 'monthly');
            this.showNext = true;
            this.showDiscountForm = true;
            this.monthlyRoute = true;
          } else if (this.type == 'corp') {
            this.type = 'corporate'
            if (this.corpCoupon == "ola") {      //Hard coded coupon for ola
              this.corporateCoupon = "MLWOLA"
              this.corp_name = "Healthvio app";
              this.corpOlaRoute = true;
              this.showMiddleSection = true;
            } else if (this.corpCoupon == "brnsn") {
              this.brnsnCouponCode = "";
              this.isCouponValid = false;
              this.brnsnForm.controls['brnsnCoupon'].setValidators([Validators.required]);
              this.brnsnForm.controls['brnsnCoupon'].updateValueAndValidity();
              this.brnsn = true;
              this.showNext = true;
              this.corp_name = "Bronson Helpnet";
              this.showMiddleSection = true;
            } else if (this.corpCoupon == "brnsn-paid") {
              this.brnsnCouponCode = "BRONSON";
              this.isCouponValid = true;
              this.brnsnForm.controls['brnsnCoupon'].clearValidators();
              this.brnsnForm.controls['brnsnCoupon'].updateValueAndValidity();
              this.brnsn = true;
              this.showNext = true;
              this.corp_name = "Bronson Helpnet";
              this.showMiddleSection = true;
            } else if (this.corpCoupon == "naturedrs") {
              this.natureDrs = true;
              this.showNext = true;
              this.corp_name = "Nature DRS";
              this.showMiddleSection = true;
            } else if (this.corpCoupon == "hollywood") {
              this.hollywood = true;
              this.showNext = true;
              this.corp_name = "City of Hollywood";
              this.showMiddleSection = true;
            } else if(this.corpCoupon == "funevo"){
              this.funevo = true;
              this.showNext = true;
              this.corp_name = "Functionally Evolved";
              this.showMiddleSection = true;
            } else if(this.corpCoupon == "managehealth"){
              this.health = true;
              this.isManageHealthBrand = true;
              this.configureManageHealthSpecificValidation(true);
              this.showNext = true;
              this.corp_name = "Managed Health";
              this.corpCouponCode = "MHEALTH";
              localStorage.setItem('corpCouponCode', 'MHEALTH');
              this.showMiddleSection = true;
              this.globalServices?.hideFooter.next(true);
            } else if(this.corpCoupon == "leathermfg"){
              this.health = true;
              this.isManageHealthBrand = false;
              this.showNext = true;
              this.corp_name = "Leatherwood Manufacturing";
              this.corpCouponCode = "LEATHERWOOD";
              localStorage.setItem('corpCouponCode', 'LEATHERWOOD');
              this.showMiddleSection = true;
              this.globalServices?.hideFooter.next(false);
            } else if(this.corpCoupon == "deepak"){
              this.health = true;
              this.isManageHealthBrand = false;
              this.showNext = true;
              this.corp_name = "Deepak Manufacturing";
              this.corpCouponCode = "LEATHERWOOD";
              localStorage.setItem('corpCouponCode', 'LEATHERWOOD');
              this.showMiddleSection = true;
              this.globalServices?.hideFooter.next(false);
            }
            // this.corporateCouponCheck('ts')
            this.getSubscriptionDetails(id, 'corporate');
          } else if (this.type == 'b2b') {
            this.b2b = true;
            this.type = 'corporate';
            // if (this.corpCoupon == "ola") {      //Hard coded coupon for ola
            //   this.corporateCoupon = "MLWOLA"
            //   this.corp_name = "Healthvio app"
            //   this.corpOlaRoute = true;
            // }
            // this.corporateCouponCheck('ts')
            this.getSubscriptionDetails(id, 'yearly');
          } else {
            this.getSubscriptionDetails(id, type);
          }
        }

      } catch (error) {
        this.mode = 'determinate';
        console.log('catchError', error);
      }
    });
  }

  public getdeatils() {
    if (this.globalServices.isBrowser) {
      this.moveToTop();
      let coupanprice = [];
      this.subscriberdata = [];
      this.originalData = JSON.parse(localStorage.getItem('planpayment'));
      let planData = JSON.parse(localStorage.getItem('planpayment'));
      if (planData) {
        let data = planData.filter(function (e) {
          return e.subscriptionId !== '';
        });
        for (let i = 0; i < data.length; i++) {
          coupanprice.push({
            originalAmount: data[i]['price'],
            subscriptionCategoryId: data[i]['planCategoryId'],
            subscriptionId: data[i]['subscriptionId'],
            isTrial: data[i]['isTrial'],
            isTrialUsed: data[i]['isTrialUsed'],
            subscriptionName: data[i]['subscriptionName'].trim(),
            subscriptionCategoryName:
              data[i]['planUsename'] == 'plan'
                ? 'general'
                : data[i]['planUsename'],
          });
        }
      }
      let url = 'billingservice/coupon/api/get';
      this.globalTotalPrice = 0;
      this.apiService.postbillData(url, coupanprice).subscribe(
        (response) => {
          if (response) {
            this.coupanData = response;
            this.appliedCode = response['appliedCoupon'];
            this.globalTotalPrice = response['globalDiscount']['discount'];
            this.expireTrialDate =
              response['noOfDays']?.length > 0
                ? new Date(response['noOfDays'][0]['expiryDate'])
                  .toLocaleString()
                  .split(',')[0]
                : '';
            this.backup_date_trial = this.expireTrialDate;
            for (let couponObj of this.coupanData['categoryDiscount']) {
              for (let [i, subObj] of planData.entries()) {
                if (
                  couponObj['subscriptionCategoryId'] == subObj['planCategoryId']
                ) {
                  planData[i]['Originalprice'] = +couponObj['originalAmount'];
                  planData[i]['priceAfterCoupon'] =
                    +couponObj['discountedAmount'];
                  planData[i]['discount'] = +couponObj['discount'];
                  break;
                }
              }
            }
            this.subscriberdata = planData;
            this.GettotalPrice();
            this.findDiscountPrice();
            localStorage.setItem(
              'planpayment',
              JSON.stringify(this.subscriberdata)
            );
          } else {
            this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
            this.GettotalPrice();
          }
        },
        (err) => {
          this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
          this.GettotalPrice();
        }
      );
    }
  }

  public backup_date_trial: any;
  public status: string = '';
  public keyCheck(e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      return false;
    }
  }

  public orderoldPlan: string = '';
  public originalPrice = [];
  discPercent;
  discountType;
  applyCode() {
    if (this.globalServices.isBrowser) {
      if (this.appliedCode != '') {
        if (this.orderoldPlan != this.appliedCode || this.deleFlag) {
          this.orderoldPlan = this.appliedCode;
          this.deleFlag = false;

          let planData = JSON.parse(localStorage.getItem('planpayment'));
          let data = planData.filter(function (e) {
            return e.subscriptionId !== '';
          });

          let coupanprice = [];
          for (let i = 0; i < data.length; i++) {
            coupanprice.push({
              originalAmount: data[i]['price'],
              subscriptionCategoryId: data[i]['planCategoryId'],
              subscriptionId: data[i]['subscriptionId'],
              isTrial: data[i]['isTrial'],
              isTrialUsed: data[i]['isTrialUsed'],
              subscriptionName: data[i]['subscriptionName'].trim(),
              subscriptionCategoryName:
                data[i]['planUsename'] == 'plan'
                  ? 'general'
                  : data[i]['planUsename'],
              type: 'subscriptions',
            });
          }
          if (this.orderoldPlan == 'MEDIA90') {
            this.status =
              'Your promo code for "90 Days Free Trial" has been applied successfully in your account';
            setTimeout(() => {
              this.status = '';
            }, 3000);
            this.expireTrialDate = new Date(1615375978832)
              ?.toLocaleString()
              ?.split(',')[0];
            return false;
          }
          let obj = {
            couponCode: this.appliedCode,
            reqData: coupanprice,
          };
          let url = 'billingservice/coupon/api/apply';
          this.apiService.postbillData(url, obj).subscribe(
            (response) => {
              if (response) {
                this.status = response['status'];
                this.removeCode('str');
                this.coupanData = response;
                this.discPercent = response?.discPercent;
                this.discountType = response?.discountType;
                this.appliedCode = response['appliedCoupon'];
                this.globalTotalPrice = response['globalDiscount']['discount'];
                if (this.coupanData['categoryDiscount'].length == 0) {
                  this.orderoldPlan = '';
                }
                for (let couponObj of this.coupanData['categoryDiscount']) {
                  for (let [i, subObj] of planData.entries()) {
                    if (
                      couponObj['subscriptionCategoryId'] ==
                      subObj['planCategoryId']
                    ) {
                      planData[i]['Originalprice'] = +couponObj['originalAmount'];
                      planData[i]['priceAfterCoupon'] =
                        +couponObj['discountedAmount'];
                      planData[i]['discount'] = +couponObj['discount'];
                      break;
                    }
                  }
                }
                this.subscriberdata = planData;

                this.GettotalPrice();
                this.findDiscountPrice();
                setTimeout(() => {
                  this.status = '';
                }, 3000);
              }
            },
            (err) => {
              this.subscriberdata = JSON.parse(
                localStorage.getItem('planpayment')
              );
              this.GettotalPrice();
            }
          );
        } else {
          this.status = 'This coupon is already applied';
          setTimeout(() => {
            this.status = '';
          }, 3000);
        }
      } else {
        this.subscriberdata = JSON.parse(localStorage.getItem('planpayment'));
        this.GettotalPrice();
      }
    }
  }

  getRound(val: any) {
    return Math.round((val + Number.EPSILON) * 100) / 100;
  }

  removeCode(val) {
    if (val == 'str') {
      this.appliedCode = '';
      this.DiscountPrice = 0;
      this.GettotalPrice();
    } else {
      this.orderoldPlan = '';
      this.appliedCode = '';
      this.DiscountPrice = 0;
      this.discPercent = undefined;
      this.expireTrialDate = this.backup_date_trial;
      this.GettotalPrice();
    }
  }
  public expireTrialDate: any = '';
  public deleFlag: boolean = false;
  delData(obj, i) {
    if (this.globalServices.isBrowser) {
      let data: any = JSON.parse(localStorage.getItem('dataArray'));
      let plan: any = JSON.parse(localStorage.getItem('planpayment'));
      data.splice(i, 1);
      this.subscriberdata.splice(i, 1);
      plan.splice(i, 1);
      this.totalPrice = 0;
      this.DiscountPrice = 0;
      data = data.slice();
      localStorage.setItem('planpayment', JSON.stringify(plan));
      localStorage.setItem('dataArray', JSON.stringify(data));
      setTimeout(() => {
        this.deleFlag = true;
        this.applyCode();
      }, 200);
    }
  }

  public pad(d) {
    return d < 10 ? '0' + d.toString() : d.toString();
  }
  public submitPaymentDetails() {
    if (this.globalServices.isBrowser) {
      try {
        this.isSubmiited = true;
        this.subscriberdata = this.subscriberdata.filter(function (e) {
          return (
            e['price'] !== null && e['price'] !== '' && e['price'] !== undefined
          );
        });

        for (let i = 0; i < this.subscriberdata.length; i++) {
          for (let j = 0; j < Object.keys(this.subscriberdata[i]).length; j++) {
            if (
              Object.keys(this.subscriberdata[i])[j] == 'planUsename' ||
              Object.keys(this.subscriberdata[i])[j] == 'Originalprice' ||
              Object.keys(this.subscriberdata[i])[j] == 'discount'
            ) {
              if (this.subscriberdata[i]['planUsename'])
                delete this.subscriberdata[i]['planUsename'];
              if (this.subscriberdata[i]['Originalprice'])
                delete this.subscriberdata[i]['Originalprice'];
              if (this.subscriberdata[i]['discount'])
                delete this.subscriberdata[i]['discount'];
            }
          }
        }
        let userToken = localStorage.getItem('userToken');
        if (this.selectedEmails?.length > 0) {
          this.selectedEmails = this.selectedEmails.filter((obj: any) => {
            if (obj?.email?.length > 0 && obj?.name?.length > 0) {
              return obj;
            }
          });
        }
        if (this.subscriberdata) {
          this.subscriberdata[0].activeTriCamp = this.invitationSendFlag
            ? 0
            : this.subscriberdata[0].activeTriCamp;
          this.subscriberdata[0].isTrial = this.isTrial;
          this.subscriberdata[0].isPromotional = this.isPromotional;
          this.subscriberdata[0].noOfDay = this.invitationSendFlag
            ? this.noOfDay
            : this.subscriberdata[0].noOfDay;
          this.subscriberdata[0].isTrialUsed = this.isTrialUsed;
          this.subscriberdata[0].occurtype = this.invitationSendFlag
            ? 'recursive'
            : this.subscriberdata[0].occurtype;
          this.subscriberdata[0].uniqueKey = this.uniqueKey;
          if (localStorage.getItem('userSubscribeInfo')) {
            let subscribeUserInfo = JSON.parse(
              localStorage.getItem('userSubscribeInfo')
            );
            this.firstName = subscribeUserInfo?.firstName
              ? subscribeUserInfo?.firstName
              : '';
            this.lastName = subscribeUserInfo?.lastName
              ? subscribeUserInfo?.lastName
              : '';
            this.email = subscribeUserInfo?.email
              ? subscribeUserInfo?.email
              : '';
            this.password = subscribeUserInfo?.password
              ? subscribeUserInfo?.password
              : '';
          }
          let data: any;
          data = {
            signUpFrom: this.flagForDiscountPlan ? 'fifty_off' : 'general',
            vid: this.vid || '',
            timezone: this.tz ? this.tz : 'America/New_York',
            couponCode: localStorage.getItem('corporateCoupon') ? localStorage.getItem('corporateCoupon') : '',
            durtype: this.subscriberdata[0].durtype,
            occurtype: this.subscriberdata[0].occurtype,
            uniqueKey: this.subscriberdata[0].uniqueKey,
            users: this.selectedEmails,
            isTrialUsed: this.isTrialUsed,
            isCorpCoupon: false,
            password: this.password
          };
          this.mode = 'indeterminate';
          let url = 'billingservice/usersubscription/payment';
          this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
            (response) => {
              this.payData = response;
              if (response.status) {
                setTimeout(() => {
                  localStorage.removeItem('bookingpage');
                  localStorage.setItem(
                    'planUserId',
                    JSON.stringify({
                      userId: this.payData['userId'],
                    })
                  );
                  this.mode = 'determinate';
                  this.changeDetectorRef.detectChanges();

                }, 1000);
                if (this.globalServices.isBrowser) {
                  return window.location.href = response.redirectUrl;
                }

              } else {
                this.subscriberdata = JSON.parse(
                  localStorage.getItem('planpayment')
                );
                this.GettotalPrice();
                this.findDiscountPrice();
                this.showAlert = true;
                this.responseMessage =
                  'Sorry, we could not complete the transaction. Please try again later!';
                this.mode = 'determinate';
              }
              this.changeDetectorRef.detectChanges();
            },
            (err) => {
              this.errorMessage = 'Something went wrong!';
              setTimeout(() => {
                this.errorMessage = '';
              }, 3000);
            }
          );
        } else {
          this.showAlert = true;
          this.responseMessage = 'Something Went Wrong!';
        }
      } catch (error) {
        console.log(error);
        this.mode = 'determinate';
        this.showAlert = true;
        this.responseMessage = 'Something Went Wrong! Please try again.';
      }
    }
  }

  public triggerCloseEvent() {
    this.showAlert = false;
  }

  getfinalprice(final) {
    if (this.globalServices.isBrowser) {
      return final;
    }
  }

  public emailDomainValidator(control: AbstractControl): {
    passwordValid: boolean;
  } {
    let pass: any = control.value;
    if (pass?.includes('@') && pass.includes('.')) {
      return null;
    } else {
      return { passwordValid: true };
    }
  }
  public emailCheck(value) {
    if (value) {
      let pass: any = value;
      if (pass?.includes('@') && pass.includes('.')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public corporateCouponCheck(calledBy) {
    let couponCode = this.corporateCoupon ? this.corporateCoupon : "invalid"
    let url = 'billingservice/coupon/get/coupon-info/' + couponCode;
    this.apiService.getDatabill(url).subscribe((response: [any]) => {
      if (response && response.length > 0) {
        this.isCouponValid = response[0].isCorporate ? true : false;

      } else {
        this.isCouponValid = false
      }
      if (calledBy == "ts" && !this.isCouponValid) {
        this.toastr.error('Link is expired, Please ask admin to renew', 'Invalid URL', {
          timeOut: 10000
        })
      }
    });
  }

  checkCouponForBrnsn(e) {
    this.brnsnCouponCode = e.target.value;
    let couponCode = e.target.value != '' ? e.target.value : "invalid"
    let url = 'billingservice/coupon/get/coupon-info/' + couponCode;
    this.apiService.getDatabill(url).subscribe((response: [any]) => {
      if (response && response.length > 0) {
        this.isCouponValid = response[0].isCorporate ? true : false;

      } else {
        this.isCouponValid = false
      }
    });
  }

  // checkCouponForDiscount(e) {
  //   this.brnsnCouponCode = e.target.value;
  //   let couponCode = e.target.value != '' ? e.target.value : "invalid"
  //   let url = 'billingservice/coupon/get/coupon-info/' + couponCode;
  //   this.apiService.getDatabill(url).subscribe((response: [any]) => {
  //     if (response && response.length > 0) {
  //       this.isCouponValid = response[0].isCorporate ? true : false;

  //     } else {
  //       this.isCouponValid = false
  //     }
  //   });
  // }

  subscriptiponCouponCheck(calledBy) {
    let couponCode = this.subcorporateCoupon ? this.subcorporateCoupon : "invalid"
    let url = 'billingservice/coupon/get/coupon-info/' + couponCode;
    this.apiService.getDatabill(url).subscribe((response: [any]) => {
      if (response && response.length > 0) {
        this.isSubsCouponValid = response[0].isCorporate ? false : true;
      } else {
        this.isSubsCouponValid = false
      }
    });
  }

  public showNext: boolean = false;
  public vid: any;
  public secondStepShow = false;
  public newMiddleSection = false;
  public questionSection = false;
  nextStep() {
    if (this.globalServices.isBrowser) {
      this.submiited = true;
      if (
        !this.password ||
        !this.confirmPassword ||
        this.confirmPassword?.length == 0 ||
        this.password?.length == 0
      ) {
        return;
      }
      if (this.confirmPassword !== this.password) {
        return;
      }
      if (this.firstName?.length < 3 || this.lastName?.length < 3) {
        return;
      }

      if (this.corporateCoupon != '') {
        if (
          (!this.isCouponValid || this.corporateCoupon?.length == 0) &&
          (this.freeRoute)
        ) {
          return;
        } else {
          if (this.globalServices.isBrowser)
            localStorage.setItem('corporateCoupon', this.corporateCoupon);
        }
      } else if (this.b2b && this.corporateCoupon == '') {
        return;
      }

      if (this.subcorporateCoupon != '') {
        if (
          (!this.isSubsCouponValid || this.subcorporateCoupon?.length == 0) &&
          (this.yearlyRoute)
        ) {
          return;
        } else {
          if (this.globalServices.isBrowser)
            localStorage.setItem('corporateCoupon', this.subcorporateCoupon);
        }
      } else {
        this.isSubsCouponValid = true
      }

      if (
        this.email != '' &&
        this.emailCheck(this.email) &&
        this.firstName != '' &&
        this.lastName != ''
      ) {
        this.errorMessage = '';

        try {
          let url = 'user/signup';
          let data: object = {
            email: this.email?.trim(),
            firstName: this.firstName,
            lastName: this.lastName,
            password: this.password,
            conpassword: this.password,
            timezone: this.tz ? this.tz : 'America/New_York',
            subscriptionType: this.b2b ? 'corporate' : '',
            type: '',
            signUpFrom: this.b2b ? "corporate" : this.thankYouSectionFlag
              ? 'opt-in_no_cc'
              : this.flagForDiscountPlan
                ? 'discounted'
                : 'general',
          };
          let data2: object = {
            email: this.email?.trim(),
            firstName: this.firstName,
            lastName: this.lastName,
          };
          this.mode = 'indeterminate';
          this.apiService
            .postFormData(url, this.globalServices.toFormData(data))
            .subscribe(
              (responseOfSignUp: any) => {

                this.submiited = false;
                if (responseOfSignUp?.success) {
                  // this.mode = 'determinate';

                  if (responseOfSignUp?.token) {
                    localStorage.setItem('userToken', responseOfSignUp?.token);
                  }
                  localStorage.setItem(
                    'userSubscribeInfo',
                    JSON.stringify({ ...data2, ...{ password: this.password } })
                  );
                  if (this.ssoOption) {
                    localStorage.setItem("sso", this.ssoOption)
                  }
                  this.vid = responseOfSignUp.vid;
                  this.showNext = !this.showNext;
                  if (this.twoStepFlow) {
                    if (this.uniqueKey == 'my-app') {
                      this.questionSection = true;
                      this.newMiddleSection = true;
                    }
                    this.showThirdStep = true;
                    this.colorSecondStep = true;
                  } else {
                    this.secondStepShow = !this.secondStepShow;
                    this.colorSecondStep = true;
                  }
                  setTimeout(() => {
                    this.moveToTop();
                  }, 500);
                  if (!this.auth2) {
                  }
                  // ========== START_LOGIN THE USER ================
                  let data = {
                    email: this.email,
                    password: this.password,
                    type: 'normal',
                  };
                  let url = 'user/login';
                  localStorage.setItem(
                    'userEmail',
                    this.email.toLocaleLowerCase()
                  );
                  localStorage.setItem('userPass', this.password);
                  this.apiService
                    .postFormData(url, data)
                    .subscribe((response2) => {
                      if (response2.success) {
                        this.globalServices.isLoggedIn = true;

                        response2['data']['siteUrl'] = response2['siteUrl'];

                        localStorage.setItem(
                          'userDetails',
                          JSON.stringify(response2['data'])
                        );
                        localStorage.setItem('userToken', response2['token']);
                        if (response2['isSubscriptionPurchased']) {
                          localStorage.setItem(
                            'isSubscriptionPurchased',
                            JSON.stringify(response2['isSubscriptionPurchased'])
                          );
                        }
                        if (responseOfSignUp?.data?.timezone) {
                          localStorage.setItem(
                            'timezone',
                            JSON.stringify(responseOfSignUp['data']['timezone'])
                          );
                        }
                        this.globalServices.userDetails = JSON.parse(
                          JSON.stringify(response2['data'])
                        );
                        this.getUserCurrentPlan();
                        this.globalServices.isActivePlanUserHave();
                        this.submitTheQuestionaire();
                        if (
                          JSON.parse(localStorage.getItem('cartdata')) !== null
                        ) {
                          let datum = [];
                          var a = [];
                          a = JSON.parse(localStorage.getItem('cartdata'));
                          a.forEach((el) => {
                            let date = el.date.split('-');
                            let dat = {
                              type: el.portal,
                              productId: el.programId,
                              productInfo: {
                                bookingStartDate:
                                  date && date[0] ? date[0] : new Date(),
                                bookingEndDate:
                                  date && date[1] ? date[1] : new Date(),
                                accommodationId: el.accommodationId,
                                noOfPeople: el.people,
                                addonsId: el.totalAddonsId,
                              },
                              pay: el.payStatus,
                            };
                            datum.push(dat);
                          });
                          const headerDict = {
                            token: localStorage.getItem('userToken'),
                          };
                          let newdatum = { data: datum };
                          let Url = 'billingservice/cartservice/create';
                          this.apiService
                            .postFormDataBilling(Url, newdatum, headerDict)
                            .subscribe((response1) => {
                              localStorage.removeItem('cartdata');
                              localStorage.setItem(
                                'cartquantity',
                                String(response1.count - 1)
                              );
                              this.globalServices.cartquantity = Number(
                                response1.count
                              );
                            });
                        } else {
                          localStorage.setItem(
                            'cartquantity',
                            String(response2.count - 1)
                          );
                          this.globalServices.cartquantity = Number(
                            response2.count
                          );
                        }
                        if (this.globalServices.direcPaymentPage) {
                          // this.mode = 'determinate';
                        }
                        let promie = new Promise((res, rej) => {
                          if (this.globalServices.priceCheck) {
                            res(this.globalServices.priceCheck);
                          } else if (this.globalServices.direcPaymentPage) {
                            res('signupNewuserMraket');
                          } else {
                            rej();
                          }
                        });

                        let userDetails = JSON.parse(
                          localStorage.getItem('userDetails')
                        );
                        this.globalServices.firstname = userDetails
                          ? userDetails.firstName
                          : '';
                        this.globalServices.imgSrc =
                          userDetails &&
                            userDetails['images'] &&
                            userDetails['images']['path']
                            ? baseUrls['images'] +
                            userDetails['images']['path'] +
                            userDetails['images']['name']
                            : 'assets/images/profile-picture.png';
                        this.globalServices.subjectTriggerForLoginDetectAtHeader.next(
                          true
                        );

                        if (this.thankYouSectionFlag) {
                          this.globalServices.postUserActivityLog({
                            loginFromUrl: 'free',
                          });
                          localStorage.setItem(
                            'userActivityLog',
                            JSON.stringify({ loginFromUrl: 'free' })
                          );
                          this.submitTheQuestionaire();
                        }
                        if (this.flagForDiscountPlan) {
                          this.globalServices.postUserActivityLog({
                            loginFromUrl: 'discount',
                          });
                          localStorage.setItem(
                            'userActivityLog',
                            JSON.stringify({ loginFromUrl: 'discount' })
                          );
                        }
                        if (
                          this.type.toLowerCase() == 'monthly' ||
                          this.type.toLowerCase() == 'quarterly' ||
                          this.type.toLowerCase() == 'yearly'
                        ) {
                          this.globalServices.postUserActivityLog({
                            loginFromUrl: this.type,
                          });
                          localStorage.setItem(
                            'userActivityLog',
                            JSON.stringify({ loginFromUrl: this.type })
                          );
                        }
                        this.globalServices?.getSubscriptionPlan();
                        promie
                          .then((val) => {
                            if (this.globalServices.direcPaymentPage) {
                              // this.mode = 'determinate';
                            } else {
                              if (this.globalServices.priceCheck) {
                              } else {
                                this.globalServices.signupStatus = true;
                                this.globalServices.subjectTriggerForPlanPage.next(
                                  true
                                );
                              }
                            }
                            this.globalServices.viewcontainerhelper.clear();
                          })
                          .catch((err) => {
                            if (this.globalServices.direcPaymentPage) {
                              // this.mode = 'determinate';
                            } else {
                              if (this.globalServices.priceCheck) {
                              } else {
                                this.globalServices.signupStatus = true;
                                this.globalServices.subjectTriggerForPlanPage.next(
                                  true
                                );
                              }
                            }
                            this.globalServices?.viewcontainerhelper?.clear();
                          });
                      } else {
                        // this.mode = 'determinate';
                        this.errorMessage = response2['message'];

                      }
                    });
                  // ========== END_LOGIN THE USER ==================
                } else {
                  // this.mode = 'determinate';
                  this.errorMessage = responseOfSignUp?.message;
                }
              },
              (error: any) => {
                // this.mode = 'determinate';
                this.errorMessage = error?.message
                  ? error?.message
                  : 'Something bad happened. Please try again.';
              }
            );
        } catch (error) {
          this.mode = 'determinate';
          this.errorMessage = error?.message
            ? error?.message
            : 'Something bad happened. Please try again.';
        }
      }
    }
  }
  surveyData;
  getSurveyQuestion() {
    this.surveyService.getSurveyQuestions().subscribe((resOfSurveyQuestion: any) => {
      if (resOfSurveyQuestion) {
        this.surveyData = Object.assign({}, resOfSurveyQuestion);
      }
    });
  }
  moveToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  ngOnDestroy() {
    if (this.globalServices.isBrowser) localStorage.removeItem('planpayment');
    this.globalServices?.hideFooter.next(false);
    this.globalServices.signupPage = {};
  }
  updateKey(event) {
    if (event.target.value) {
      if (event.target.value.trim().toString().length == 2) {
        if (!event.target.value.trim().toString().includes('/'))
          this.paymentcard.controls['expiryYear'].setValue(
            this.paymentcard.controls['expiryYear'].value + '/'
          );
      }
    }
  }
  
  openloginmodal() {
    if (
      this.globalServices.isBrowser &&
      document.getElementById('google-jssdk')
    )
      document
        .getElementById('google-jssdk')
        .parentNode.removeChild(document.getElementById('google-jssdk'));
    this.globalServices.signupPage = {
      show: true,
      id: this._id,
      type: this.type,
    };
    this.globalServices.viewcontainerhelper = this.viewContainerRef;
    this.globalServices.triggerlogin(this.viewContainerRef, this.cfr);
  }

  // ====================== GMAIL CONTACT LIST ==========================
  password = '';
  confirmPassword = '';
  public auth2: any;
  googleSDK() {
    window['googleSDKLoaded'] = () => {
      window['gapi'].load('auth2', () => {
        this.auth2 = window['gapi'].auth2.init({
          discoveryDocs: [
            'https://people.googleapis.com/$discovery/rest?version=v1',
          ],
          client_id:
            '968207026071-ae8fso02rfo2dhf67nb51u8auh2fm5jf.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          scope:
            'profile email https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/contacts.other.readonly',
        });
        this.prepareLoginButton();
      });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'google-jssdk');
  }

  prepareLoginButton() {
    if (this.globalServices.isBrowser) {
      this.auth2.attachClickHandler(
        document.getElementById('loginRef'),
        {},
        (googleUser) => {
          this.personalizeSection = false;
          let profile = googleUser.getBasicProfile();
          this.mode = 'indeterminate'; // it will stop when we get contacts in code Method
          this.changeDetectorRef.detectChanges();

          setTimeout(() => {
            this.loadPeopleApi();
          }, 100);
        }
      );
    }
  }
  loadPeopleApi() {
    gapi.client.load(
      'https://people.googleapis.com/$discovery/rest',
      'v1',
      this.executeForOtherContacts
    );
  }

  showContacts() {
    const request = gapi.client.people.people.connections
      .list({
        resourceName: 'people/me',
        pageSize: 1500,
        'requestMask.includeField':
          'person.phone_numbers,person.organizations,person.email_addresses,person.names',
      })
      .then((res) => {
        self.code(res);
      });

  }
  // Make sure the client is loaded and sign-in is complete before calling this method.
  executeForOtherContacts() {
    return gapi.client.people.otherContacts
      .list({
        pageSize: 1000,
        readMask: 'emailAddresses,names',
      })
      .then(
        function (response) {
          if (response?.result?.otherContacts?.length > 0) {
            self.otherContactSet(response?.result?.otherContacts);
          }
        },
        function (err) {
          console.error('Execute error', err);
        }
      );
  }
  googleOtherContactSerachMessage;
  searchGoogleGmailContacts(queryPassed) {
    return gapi.client.people.otherContacts
      .search({
        query: queryPassed,
        pageSize: 10,
        readMask: 'emailAddresses,names',
      })
      .then(
        function (response) {
          if (response?.result?.results?.length > 0) {
            self.otherContactSearchSet(response?.result?.results);
          } else {
            self.googleOtherContactSerachMessage =
              'No result for required search !!';
            setTimeout(() => {
              self.googleOtherContactSerachMessage = '';
              self.changeDetectorRef?.detectChanges();
            }, 6000);
            self.changeDetectorRef?.detectChanges();
          }
        },
        function (err) {
          console.error('Execute error', err);
        }
      );
  }
  otherContactSet(contacts) {
    if (contacts?.length > 0) {
      this.mode = 'indeterminate';
      this.emailContactListArray = [];
      contacts?.forEach((obj: any) => {
        if (
          obj?.emailAddresses &&
          obj?.emailAddresses[0] &&
          obj?.emailAddresses[0]?.value &&
          obj?.names &&
          obj?.names[0] &&
          obj?.names[0]?.displayName
        ) {
          this.emailContactListArray = [
            ...this.emailContactListArray,
            ...[
              {
                email: obj?.emailAddresses[0]?.value,
                name: obj?.names[0]?.displayName,
              },
            ],
          ];
        }
      });
      this.emailFlag = true;
      this.mode = 'determinate';
      this.changeDetectorRef?.detectChanges();
    }
  }
  otherContactSearchSet(searchContactResult) {
    if (searchContactResult?.length > 0) {
      this.mode = 'indeterminate';
      this.emailContactListArray = [];
      searchContactResult?.forEach((obj: any) => {
        if (
          obj?.person?.emailAddresses &&
          obj?.person?.emailAddresses[0] &&
          obj?.person?.emailAddresses[0]?.value &&
          obj?.person?.names &&
          obj?.person?.names[0] &&
          obj?.person?.names[0]?.displayName
        ) {
          this.emailContactListArray = [
            ...this.emailContactListArray,
            ...[
              {
                email: obj?.person?.emailAddresses[0]?.value,
                name: obj?.person?.names[0]?.displayName,
              },
            ],
          ];
        }
      });
      this.mode = 'determinate';
      this.changeDetectorRef?.detectChanges();
    }
  }
  selectedEmails = [];
  selectedEmailCall(userInfo) {
    let contactFound2 = this.selectedEmails.find(
      ({ email }) => email === userInfo?.email
    );
    if (contactFound2) {
      let index = this.selectedEmails.indexOf(userInfo);
      this.selectedEmails.splice(index, 1);
    } else {
      this.selectedEmails.push(userInfo);
    }

  }
  inviteGoogleContact() {
  }

  emailContactListArray = [];
  emailFlag = false;
  code(data) {
    this.emailContactListArray = [];
    if (data?.result?.connections?.length > 0) {
      this.emailFlag = true;
      data?.result?.connections?.forEach((obj: any) => {
        if (
          obj?.emailAddresses &&
          obj?.emailAddresses[0] &&
          obj?.emailAddresses[0]?.value &&
          obj?.names &&
          obj?.names[0] &&
          obj?.names[0]?.displayName
        ) {
          this.emailContactListArray = [
            ...this.emailContactListArray,
            ...[
              {
                email: obj?.emailAddresses[0]?.value,
                name: obj?.names[0]?.displayName,
              },
            ],
          ];
        }
      });
      this.mode = 'determinate';
      this.executeForOtherContacts();
      this.changeDetectorRef.detectChanges();
    } else {
      this.executeForOtherContacts();
    }
  }
  
  //  ========================= Microsoft Account =================================

  async signIn(): Promise<void> {
    this.personalizeSection = false;
    await this.authService
      .signIn()
      .then((res: any) => {
        this.getContacts();
      })
      .catch((error: any) => {
      });
  }
  getContacts() {
    this.mode = 'indeterminate';
    this.changeDetectorRef.detectChanges();
    this.emailContactListArray = [];
    this.graphService.getContacts().then((contacts) => {
      contacts?.forEach((obj) => {
        if (
          obj?.emailAddresses &&
          obj?.emailAddresses[0]?.address &&
          obj?.givenName
        ) {
          this.emailContactListArray.push({
            email: obj?.emailAddresses[0]?.address,
            name: obj?.givenName,
          });
        }
      });
      this.mode = 'determinate';
      this.emailFlag = true;
      if (this.globalServices.isBrowser)
        localStorage.removeItem('step');
      this.changeDetectorRef.detectChanges();
    });
  }
  showThirdStep = false;
  moveToThirdStep() {
    if (this.selectedEmails?.length >= 3) {
      this.secondStepShow = !this.secondStepShow;
      this.showThirdStep = !this.showThirdStep;
    } else {
      this.secondStepShow = !this.secondStepShow;
      this.showThirdStep = !this.showThirdStep;
    }
  }
  popUpMessage;
  invitationSendFlag = false;
  noOfDay;
  sendInvite() {
    this.mode = 'indeterminate';
    if (this.selectedEmails?.length >= 3) {
      let obj = {
        subscription: {
          id: this.planId,
          name: this.plan_name,
          type: this.type,
        },
        users: this.selectedEmails,
        userName: this.firstName
          ? this.firstName + (this.lastName ? ' ' + this.lastName : '')
          : this.globalServices?.userDetails?.name,
        email: this.email
          ? this.email
          : this.globalServices?.userDetails?.email,
      };
      this.apiService.sendInviteMail('user/invite', obj).subscribe(
        (response: any) => {
          if (response?.status == 'success') {
            this.invitationSendFlag = true;
            this.noOfDay = response?.noOfDay;
            this.secondStepShow = !this.secondStepShow;
            this.showThirdStep = !this.showThirdStep;
            this.colorThirdStep = true;
          }
          this.mode = 'determinate';
          this.changeDetectorRef.detectChanges();
        },
        (error: any) => {
          this.mode = 'determinate';
        }
      );
    } else {
      this.popUpMessage =
        'Please select atleast 3 contact for Free Subscription !!';
      setTimeout(() => {
        this.popUpMessage = '';
      }, 3000);
      this.mode = 'determinate';
    }
  }
  secondStepSkipped = false;
  skip() {
    this.secondStepSkipped = true;
    this.secondStepShow = false;
    this.showThirdStep = true;
    this.colorThirdStep = true;
  }
  // ===================== Yahoo Mail OAuth Login & import Contacts List =============
  authForYahoo() {
    const appId = 'rXMFbZGM';
    const clientId =
      'dj0yJmk9Q2pUR0NMUTNIeEZmJmQ9WVdrOWNsaE5SbUphUjAwbWNHbzlNQT09JnM9Y29uc3VtZXJzZWNyZXQmc3Y9MCZ4PWYy';
    const redirectUri =
      'https://mlwdev.clientwork.xyz/register/5f3a332be019a9049b0ee8b5-monthly';
    const clientSecret = 'ab8bed60bf197fdd9093167ae2ee75c476699c56';

    const body = {
      client_id: clientId,
      redirect_uri:
        'https://mlwdev.clientwork.xyz/register/5f3a332be019a9049b0ee8b5-monthly',
      response_type: 'code',
    };
    this.httpClient
      .post<any>('https://api.login.yahoo.com/oauth2/request_auth', body, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods':
            'GET, OPTIONS, PUT, POST, DELETE, PATCH, HEAD',
          'Access-Control-Allow-Headers': 'Content-Type, x-requested-with',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          Authorization: 'Basic ' + btoa(`${clientId}:${clientSecret}`),
        }),
      })
      .subscribe(
        (data) => {
        },
        (err: HttpErrorResponse) => {
        }
      );
  }
  goBackFromSecondStep() {
    if (this.globalServices.isBrowser) {
      this.secondStepShow = false;
      if (localStorage.getItem('userSubscribeInfo')) {
        let subscribeUserInfo = JSON.parse(
          localStorage.getItem('userSubscribeInfo')
        );
        this.firstName = subscribeUserInfo?.firstName
          ? subscribeUserInfo?.firstName
          : '';
        this.lastName = subscribeUserInfo?.lastName
          ? subscribeUserInfo?.lastName
          : '';
        this.email = subscribeUserInfo?.email ? subscribeUserInfo?.email : '';
      }
      this.showNext = false;
      if (this.twoStepFlow) {
        this.showThirdStep = false;
        this.colorThirdStep = false;
      } else {
        this.secondStepShow = false;
        this.colorSecondStep = false;
      }
    }
  }
  // ================================ personalize Invite =============================
  personalizeSection = false;
  personalizeInvite() {
    this.personalizeSection = true;
    this.emailFlag = false;
    const group = new FormGroup({
      email: new FormControl('', [Validators.required, Validators?.email]),
      name: new FormControl('', Validators.required),
    });
    const group1 = new FormGroup({
      email: new FormControl('', [Validators.required, Validators?.email]),
      name: new FormControl('', Validators.required),
    });
    const group2 = new FormGroup({
      email: new FormControl('', [Validators.required, Validators?.email]),
      name: new FormControl('', Validators.required),
    });

    const group3 = new FormGroup({
      email: new FormControl('', [Validators.required, Validators?.email]),
      name: new FormControl('', Validators.required),
    });

    const group4 = new FormGroup({
      email: new FormControl('', [Validators.required, Validators?.email]),
      name: new FormControl('', Validators.required),
    });
    const group5 = new FormGroup({
      email: new FormControl('', [Validators.required, Validators?.email]),
      name: new FormControl('', Validators.required),
    });
    const group6 = new FormGroup({
      email: new FormControl('', [Validators.required, Validators?.email]),
      name: new FormControl('', Validators.required),
    });
    this.emailPersonalize.push(group);
    this.emailPersonalize.push(group1);
    this.emailPersonalize.push(group2);
    this.emailPersonalize.push(group3);
    this.emailPersonalize.push(group4);
    this.emailPersonalize.push(group5);
    this.emailPersonalize.push(group6);
  }

  emailPersonalize = new FormArray([]);
  addMoreEmailPersonalize() {
    if (this.emailPersonalize?.length < 7) {
      const group = new FormGroup({
        email: new FormControl('', [Validators.required, Validators?.email]),
        name: new FormControl('', Validators.required),
      });

      this.emailPersonalize.push(group);
    } else {
      this.showAlert = true;
      this.responseMessage = 'Maximum 7 Entries Allowed !!';
    }
  }

  removeEmailPersonalize(index: number) {
    this.emailPersonalize.removeAt(index);
  }
  clear() {
    this.emailPersonalize.clear();
  }
  replace() {
    this.emailPersonalize.setControl(0, new FormControl(''));
  }
  submittedPersonalizeEmailForm = false;
  submitEmailPersonalize() {
    this.submittedPersonalizeEmailForm = true;
    if (
      this.emailPersonalize?.length == 3 ||
      this.emailPersonalize?.length > 3
    ) {
      this.emailContactListArray = [];
      this.emailContactListArray = this.emailPersonalize.getRawValue();
      for (let i = 0; i < 3; i++) {
        if (this.emailContactListArray[i]?.email) {
          for (let j = i + 1; j < 3; j++) {
            if (
              this.emailContactListArray[i]?.email ==
              this.emailContactListArray[j]?.email
            ) {
              this.showAlert = true;
              this.responseMessage = 'Same Email Repeatation Not Allowed !!';
              return;
            }
          }
        } else {
          this.showAlert = true;
          this.responseMessage =
            'Please provide Minimum 3 emails To Claim 3-Month Free Membership.';
          return;
        }
      }
      this.selectedEmails = this.emailPersonalize.getRawValue();
      this.sendInvite();
    } else {
      this.showAlert = true;
      this.responseMessage = 'Email or Name Should Be Valid !!';
    }
  }
  goolgeSearchSection = false;
  googleSearchContact;
  searchCallSubjectForGmailContact = new Subject();
  oldEmailContactListArray = [];
  googleSearchEnableMethodCall() {
    if (this.googleSearchContact?.length > 2) {
      if (this.oldEmailContactListArray?.length == 0) {
        this.oldEmailContactListArray = this.emailContactListArray;
      }
      let trimSearchKeyword = this.googleSearchContact.trim();
      this.goolgeSearchSection = true;
      this.searchCallSubjectForGmailContact.next(trimSearchKeyword);
      this.changeDetectorRef.detectChanges();
    } else {
      if (this.oldEmailContactListArray?.length !== 0) {
        this.emailContactListArray = this.oldEmailContactListArray;
        this.changeDetectorRef.detectChanges();
      }
    }
  }
  checkExist(emailPassed) {
    if (this.selectedEmails?.length > 0) {
      let flagForEmailPassed = false;
      for (let i = 0; i < this.selectedEmails?.length; i++) {
        if (this.selectedEmails[i]?.email == emailPassed) {
          flagForEmailPassed = true;
          return true;
        }
      }
      if (!flagForEmailPassed) {
        return false;
      }
    } else {
      return false;
    }
  }
  public triggerCloseEvent2(eventPassed) {
    this.showAlert2 = false;
    if (eventPassed?.success == true) {
      this.secondStepSkipped = true;
      this.secondStepShow = false;
      this.showThirdStep = true;
      this.colorThirdStep = true;
    }
  }
  userCurrentPlans = [];
  getUserCurrentPlan() {
    if (this.globalServices.isBrowser) {
      if (this.globalServices?.isLoggedIn) {
        const userId = JSON.parse(localStorage.getItem('userDetails'))?._id;
        this.apiService
          .getDatabill(`billingservice/usersubscription/subs/${userId}`)
          .subscribe((subscribePlan: any) => {
            if (subscribePlan) {
              this.userCurrentPlans = subscribePlan;
              localStorage.setItem(
                'userSubscriptionPlan',
                JSON.stringify(subscribePlan)
              );
              if (subscribePlan && subscribePlan[0]?.isExpired == 1) {
                this.globalServices.moveToPlanPage.next(true);
                localStorage.setItem('moveToPlanPage', 'true');
              } else {
                this.globalServices.moveToPlanPage.next(false);
                localStorage.setItem('moveToPlanPage', 'false');
              }
            }
          });
      }
    }
  }

  public accordianChange(index: number): void {
    if (this.globalServices.isBrowser) {
      let els: any = document.getElementsByClassName('accordian');
      if (els) {
        let el: any = document.getElementsByClassName('accordian')[index];
        if (el.classList.contains('active')) {
          el.classList.remove('active');
        } else {
          for (let elem of els) {
            elem.classList.remove('active');
          }
          el.classList.add('active');
        }
      }
    }
  }
  rating = 5;
  testinomialData = [
    {
      name: 'Mary Jones',
      message:
        "I'm enjoying the meditation! I also appreciate the accessibility of the workouts to help me improve my strength and general health.",
      rating: 5,
      designation: 'President & Founder, LDPR',
    },
    {
      name: 'Steven V, Canada',
      message:
        'Great variety of exercises and programs so I don’t get bored. Really like that I can track my meals too.',
      rating: 5,
      designation: 'President, Pegasus Knowledge Solutions, Inc.',
    },
    {
      name: 'Gloria S, NJ',
      message:
        'Saves me time, money, and the risk of getting bored  because everything is in one app.',
      rating: 4.5,
      designation: 'President & Founder, LDPR',
    },
    {
      name: 'Kim W, AZ',
      message:
        'Just finished my first barre class yesterday - what a nice change from my usual workouts, and I’m learning new skills! Maybe I’ll try boxing tomorrow...',
      rating: 5,
      designation: 'President, Pegasus Knowledge Solutions, Inc.',
    },
  ];
  slideConfigForTestimonial = {};
  initCarouselConfig() {
    this.slideConfigForTestimonial = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 839,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
          },
        },
      ],
    };
  }
  planInfo;
  getSubscriptionPlan() {
    if (this.globalServices?.isBrowser) {
      const token = localStorage.getItem('Token')
        ? localStorage.getItem('Token')
        : '';
      this.subscriptionPlanService
        ?.getSubscriptionDetail()
        .subscribe((response: any) => {
          if (response) {
            this.planInfo = response;
          }
        });
    }
  }
  plan = 'Monthly Plan'; //Premium Plan
  planSelected(indexPassed) {
    if (indexPassed == 0) {
      this.plan = 'Monthly Plan';
    }
    if (indexPassed == 1) {
      this.plan = 'Premium Plan';
    }
    if (indexPassed == 2) {
      this.plan = 'Quarterly Plan';
    }
  }
  clickOnPlan(idPassed) {
    if (idPassed) {
      if (this.plan == 'Premium Plan') {
        this.newMiddleSection = false;
        this.router.navigate([`register/${idPassed}-yearly`]);
      }
      if (this.plan == 'Monthly Plan') {
        this.newMiddleSection = false;
        this.router.navigate([`register/${idPassed}-monthly`]);
      }
      if (this.plan == 'Quarterly Plan') {
        this.newMiddleSection = false;
        this.router.navigate([`register/${idPassed}-quarterly`]);
      }
    } else {
      this.showAlert = true;
      this.popUpMessage = 'Something went wrong. Please try again !!';
    }
  }
  newMiddleSectionShouldBeNonVisible = false;
  monthlyPlanSelected(idPassed) {
    if (this.globalServices.isBrowser) {
      setTimeout(() => {
        if (idPassed) {
          this.showThirdStep = true;
          if (this.plan == 'Premium Plan') {
            this.newMiddleSection = false;
            this.newMiddleSectionShouldBeNonVisible = true;
            this.globalServices?.postUserActivityLog({
              planSelectionCompleted: 'yearly',
            });
            let localStorageObj = JSON.parse(
              localStorage.getItem('userActivityLog')
            );
            localStorage.setItem(
              'userActivityLog',
              JSON.stringify({
                ...localStorageObj,
                ...{ planSelectionCompleted: 'yearly' },
              })
            );

            setTimeout(() => {
              this.router.navigateByUrl(
                `register/${idPassed}-yearly`
              );
            }, 200);
          }
          if (this.plan == 'Monthly Plan') {
            this.newMiddleSection = false;
            this.newMiddleSectionShouldBeNonVisible = true;
            this.globalServices?.postUserActivityLog({
              planSelectionCompleted: 'monthly',
            });
            let localStorageObj = JSON.parse(
              localStorage.getItem('userActivityLog')
            );
            localStorage.setItem(
              'userActivityLog',
              JSON.stringify({
                ...localStorageObj,
                ...{ planSelectionCompleted: 'monthly' },
              })
            );

            setTimeout(() => {

              this.router.navigateByUrl(
                `register/${idPassed}-monthly`
              );
            }, 200);
          }
          if (this.plan == 'Quarterly Plan') {
            this.newMiddleSection = false;
            this.newMiddleSectionShouldBeNonVisible = true;
            this.globalServices?.postUserActivityLog({
              planSelectionCompleted: 'quarterly',
            });
            let localStorageObj = JSON.parse(
              localStorage.getItem('userActivityLog')
            );
            localStorage.setItem(
              'userActivityLog',
              JSON.stringify({
                ...localStorageObj,
                ...{ planSelectionCompleted: 'quarterly' },
              })
            );
            setTimeout(() => {
              this.router.navigateByUrl(`register/${idPassed}-quarterly`);
            }, 200);
          }
        } else {
          this.showAlert = true;
          this.popUpMessage = 'Something went wrong. Please try again !!';
        }
      }, 500);
    }
  }

  planDurationObject;
  getSubscriptionDetails(id, type) {
    if (this.globalServices.isBrowser) {
      this.mode = 'indeterminate';
      let urls =
        'billingservice/subscription/detail/' +
        id +
        '?type=' +
        type.toLowerCase();
      this.apiService.getsignupData(urls).subscribe(
        (res) => {
          if (res && res['data'] && res['data']) {
            let response: any = res['data'];
            this.plan_name = res['data']['name'];
            this.isTrial = res['data']?.isTrial;
            this.uniqueKey = res['data']?.uniqueKey;
            this.planId = res['data']?.['_id'];
            this.responsePur = res['isPlanPurchased'];
            this.userSubscriptionResult = res['userSubscriptionResult']
              ? res['userSubscriptionResult']
              : 'false';
            this.isPromotional = res['data']['isPromotional'];
            this.activeFreeTrial = res['data']['activeFreeTrial'][0];
            this.isTrialUsed = res['userSubscriptionResult']['isTrialUsed'];
            this.isPlanPurchased = res['isPlanPurchased'];
            if (res['data']['isPromotional'] == 0) {
              this.secondStepSkipped = true;
              this.twoStepFlow = true;
              if (this?.globalServices?.isLoggedIn) {
                this.secondStepShow = false;
                this.thankYouSectionFlag ? (this.showThirdStep = false) : '';
                this.colorSecondStep = true;
                if (!this.newMiddleSectionShouldBeNonVisible) {
                  this.isTrialUsed == 1
                    ? (this.questionSection = false)
                    : (this.questionSection = true);

                  this.thankYouSectionFlag ? (this.newMiddleSection = true) : ''; // if "free" offer then 1st step of questionaire is there !!
                  this.flagForDiscountPlan ? (this.newMiddleSection = false) : ''; // if "fiftYOff" offer then 1st step of questionaire is there !!
                }

                if (res['data'] && res['data']?.uniqueKey !== 'my-app') {
                  this.newMiddleSection = false;
                }
                setTimeout(() => {
                  if (localStorage.getItem('userActivityLog')) {
                    this.userActivityLog = JSON.parse(
                      localStorage.getItem('userActivityLog')
                    );
                    console.log(
                      'getSubscriptionDetails',
                      this.userActivityLog,
                      this.userActivityLog?.questionaireCompleted
                    );
                    if (this.userActivityLog?.questionaireCompleted) {
                      this.questionSection = false;
                      this.newMiddleSection = false;
                      this.showThirdStep = true;

                    } else {
                      this.questionSection = true;
                      if (this.flagForDiscountPlan) {
                        this.newMiddleSection = true;
                      }
                    }
                    if (this.userActivityLog?.planSelectionCompleted) {
                      this.questionSection = false;
                      this.newMiddleSection = false;
                      this.showThirdStep = true;
                    }
                    if (
                      this.userActivityLog?.planSelectionCompleted ==
                      'quarterly' &&
                      this.type == 'monthly'
                    ) {
                      setTimeout(() => {
                        this.router.navigateByUrl(
                          `register/${this.planId}-quarterly`
                        );
                      }, 200);
                    }
                    if (
                      this.type == 'free' &&
                      this.userActivityLog?.paymentCompleted == true &&
                      this?.userActivityLog?.loginFromUrl == 'free' &&
                      this?.userActivityLog?.questionaireCompleted
                    ) {
                      location.href = 'myaccount/subscription';
                    }
                  }
                }, 0);
              }
            }
            this.planDurationObject = res['data']['planDurationObject'];
            this.isExpired = res['userSubscriptionResult']['isExpired'];
            this.noOfDay = res['data']['noOfDay']
            if (res?.['data']?.['details']?.length > 0)
              this.details_plan = res['data']['details'];
            this.mode = 'determinate';
            let freeresponse: any = res['freePlan'];
            let free_data: any = [freeresponse];
            let data = [response];
            let requireddata = [];
            if (response?.planCategory?.name != 'General' && false) {
              let finalprice = 0;
              let data = free_data;
              let selected_Plan = data[0]['planDurationObject']?.filter(function (
                e
              ) {
                return e.type.toLowerCase() === type.toLowerCase();
              });
              if (type.toLowerCase() == 'monthly') {
                finalprice =
                  selected_Plan && selected_Plan[0]
                    ? selected_Plan[0]['price'] -
                    (selected_Plan[0]['price'] / 100) *
                    +(data[0]['shopDiscount'] ? data[0]['shopDiscount'] : 0)
                    : undefined;
              } else if (type.toLowerCase() == 'yearly' && selected_Plan) {
                finalprice =
                  ((selected_Plan[0]['price'] -
                    (selected_Plan[0]['price'] / 100) *
                    +data[0]['shopDiscount']) /
                    12) *
                  12;
              }
              requireddata.push({
                price: finalprice,
                subscriptionId:
                  (data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0] &&
                    data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['_id']) ||
                  '',
                subscriptionName:
                  (data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0] &&
                    data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['name']) ||
                  '',
                subscriptionType: type.toLowerCase(),
                planCategoryId:
                  data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['planCategoryId']
                    ? data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['planCategoryId']
                    : '',
                activeTriCamp:
                  data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['activeTriCamp'],
                isTrial:
                  data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['isTrial'],
                noOfDay:
                  data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['noOfDay'],
                plandur:
                  data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['plandur']
                    ? data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['plandur']
                    : 1,
                durtype:
                  data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0][Object.keys(data[0])[0]]['durtype']
                    ? data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0][Object.keys(data[0])[0]]['durtype']
                    : type.toLowerCase().substr(0, type.toLowerCase().length - 2),
                isTrialUsed: 0,
                occurtype:
                  data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['occurtype']
                    ? data[0] &&
                    data[0][Object.keys(data[0])[0]] &&
                    data[0]['occurtype']
                    : '',
                planUsename: type.toLowerCase(),
              });
            }
            let finalprice = 0;
            this.showplan = response?.isTrial;
            if (data[0].planCategory.name == 'General') {
              let selected_Plan = data[0]['planDurationObject'].filter(function (
                e
              ) {
                return e.type.toLowerCase() === type.toLowerCase();
              });
              if (type.toLowerCase() == 'monthly') {
                finalprice =
                  selected_Plan[0]['price'] -
                  (selected_Plan[0]['price'] / 100) *
                  +(data[0]['shopDiscount'] ? data[0]['shopDiscount'] : 0);
              } else if (type.toLowerCase() == 'yearly') {
                finalprice =
                  ((selected_Plan[0]['price'] -
                    (selected_Plan[0]['price'] / 100) *
                    +data[0]['shopDiscount']) /
                    12) *
                  12;
              } else if (type.toLowerCase() == 'quarterly') {
                finalprice = selected_Plan[0]['price'];
              }
            } else {
              finalprice = data[0].planprice;
            }
            requireddata.push({
              price: finalprice,
              subscriptionId:
                (data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0] &&
                  data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['_id']) ||
                '',
              subscriptionName:
                (data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0] &&
                  data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['name']) ||
                '',
              subscriptionType:
                type.toLowerCase() == 'free' ? 'trial' : type.toLowerCase(),
              planCategoryId:
                data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['planCategoryId']
                  ? data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['planCategoryId']
                  : '',
              activeTriCamp:
                data[0] &&
                data[0][Object.keys(data[0])[0]] &&
                data[0]['activeTriCamp'],
              triCapmDurStart:
                data[0] &&
                data[0][Object.keys(data[0])[0]] &&
                data[0]['triCapmDurStart'],
              triCapmDurEnd:
                data[0] &&
                data[0][Object.keys(data[0])[0]] &&
                data[0]['triCapmDurEnd'],
              isTrial:
                data[0] && data[0][Object.keys(data[0])[0]] && data[0]['isTrial'],
              noOfDay:
                data[0] && data[0][Object.keys(data[0])[0]] && data[0]['noOfDay'],
              plandur:
                data[0] && data[0][Object.keys(data[0])[0]] && data[0]['plandur']
                  ? data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['plandur']
                  : 1,
              durtype:
                data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0][Object.keys(data[0])[0]]['durtype']
                  ? data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0][Object.keys(data[0])[0]]['durtype']
                  : type.toLowerCase(),
              isTrialUsed: 0,
              occurtype:
                data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['occurtype']
                  ? data[0] &&
                  data[0][Object.keys(data[0])[0]] &&
                  data[0]['occurtype']
                  : '',
              planUsename: type.toLowerCase(),
            });
            localStorage.setItem('planpayment', JSON.stringify(requireddata));
            this.mode = 'determinate';
            this.getdeatils();
          }
        },
        (error: any) => {
          this.mode = 'determinate';
          console.log('error_logged', error);
        }
      );
    }
  }

  questionAnsSelectedArray = [];
  questionSelectionChange(eventPassed) {
    const value = eventPassed?.target?.value;
    if (value) {
      if (this.questionAnsSelectedArray?.includes(value)) {
        const index = this.questionAnsSelectedArray?.indexOf(value);
        this.questionAnsSelectedArray?.splice(index, 1);
      } else {
        this.questionAnsSelectedArray?.push(value);
      }
    }
  }
  onItemChange(value) {
    this.ageGroup = value;
  }

  errorMessageForQuestionaire = null;
  submitTheQuestionaire() {
    this.mode = 'indeterminate';
    const obj = {
      "wellness_interest": "improving_physical;managing_stress;wellness_travel",
      "age_group_interest": "25-34",
      "city": "mumbai",
      "state": "maharastra",
      "country": "India"
    };
    this.apiService?.postuserDataWithToken('user-data', obj).subscribe(
      (resOfQuestionaire: any) => {
        this.newMiddleSection = false;
        if (resOfQuestionaire?.status) {
          this.globalServices?.postUserActivityLog({
            questionaireCompleted: true,
          });
          let localStorageObj = JSON.parse(
            localStorage.getItem('userActivityLog')
          );
          localStorage.setItem(
            'userActivityLog',
            JSON.stringify({
              ...localStorageObj,
              ...{ questionaireCompleted: true },
            })
          );
          this.questionSection = false;
          if (this.flagForDiscountPlan) {
            this.planSelected(0);
            setTimeout(() => {
              this.newMiddleSectionShouldBeNonVisible = true;
              this.newMiddleSection = false;
              this.showThirdStep = true;
              this.getSubscriptionDetails(
                this.planInfo?.data?._id,
                'monthly'
              );
            }, 100);
          }
          if (this.thankYouSectionFlag) {
            this.submitPaymentDetailsIfUserNotUseCard();
          }
        } else {
          if (resOfQuestionaire?.msg == 'Account already created') {
            this.responseMessage = 'Account already created !!';
            this.showAlert = true;
          } else {
            this.responseMessage = 'Please try again !!';
            this.showAlert = true;
          }
        }
      },
      (error) => {
      }
    );
  }


  submitPaymentDetailsIfUserNotUseCard() {
    this.mode = 'indeterminate';
    if (this.globalServices.isBrowser) {
      try {
        this.subscriberdata = this.subscriberdata.filter(function (e) {
          return (
            e['price'] !== null && e['price'] !== '' && e['price'] !== undefined
          );
        });

        for (let i = 0; i < this.subscriberdata.length; i++) {
          for (let j = 0; j < Object.keys(this.subscriberdata[i]).length; j++) {
            if (
              Object.keys(this.subscriberdata[i])[j] == 'planUsename' ||
              Object.keys(this.subscriberdata[i])[j] == 'Originalprice' ||
              Object.keys(this.subscriberdata[i])[j] == 'discount'
            ) {
              if (this.subscriberdata[i]['planUsename'])
                delete this.subscriberdata[i]['planUsename'];
              if (this.subscriberdata[i]['Originalprice'])
                delete this.subscriberdata[i]['Originalprice'];
              if (this.subscriberdata[i]['discount'])
                delete this.subscriberdata[i]['discount'];
            }
          }
        }
        let userToken = localStorage.getItem('userToken');
        if (this.selectedEmails?.length > 0) {
          this.selectedEmails = this.selectedEmails.filter((obj: any) => {
            if (obj?.email?.length > 0 && obj?.name?.length > 0) {
              return obj;
            }
          });
        }
        if (this.subscriberdata) {
          this.subscriberdata[0].activeTriCamp = this.invitationSendFlag
            ? 0
            : this.subscriberdata[0].activeTriCamp;
          this.subscriberdata[0].isTrial = this.isTrial;
          this.subscriberdata[0].isPromotional = this.isPromotional;
          this.subscriberdata[0].noOfDay = this.invitationSendFlag
            ? this.noOfDay
            : this.subscriberdata[0].noOfDay;
          this.subscriberdata[0].isTrialUsed = this.isTrialUsed;
          this.subscriberdata[0].occurtype = this.invitationSendFlag
            ? 'recursive'
            : this.subscriberdata[0].occurtype;
          this.subscriberdata[0].uniqueKey = this.uniqueKey;
          if (localStorage.getItem('userSubscribeInfo')) {
            let subscribeUserInfo = JSON.parse(
              localStorage.getItem('userSubscribeInfo')
            );
            this.firstName = subscribeUserInfo?.firstName
              ? subscribeUserInfo?.firstName
              : '';
            this.lastName = subscribeUserInfo?.lastName
              ? subscribeUserInfo?.lastName
              : '';
            this.email = subscribeUserInfo?.email
              ? subscribeUserInfo?.email
              : '';
            this.password = subscribeUserInfo?.password
              ? subscribeUserInfo?.password
              : '';
          } else {
            if (localStorage.getItem('userDetails')) {
              let userDetails = JSON.parse(localStorage.getItem('userDetails'));
              this.firstName = userDetails?.firstName
                ? userDetails?.firstName
                : '';
              this.lastName = userDetails?.lastName
                ? userDetails?.lastName
                : '';
              this.email = userDetails?.email ? userDetails?.email : '';
              this.password = userDetails?.password
                ? userDetails?.password
                : '';
            }
          }
          let data: any;
          this.corporateCoupon = localStorage.getItem('corporateCoupon');

          data = {
            signUpFrom: 'corporate',
            vid: this.vid || '',
            timezone: this.tz ? this.tz : 'America/New_York',
            couponCode: this.corporateCoupon ? this.corporateCoupon : '',
            durtype: 'yearly',
            occurtype: this.subscriberdata[0].occurtype,
            uniqueKey: this.subscriberdata[0].uniqueKey,
            users: [],
            isTrialUsed: 0,
            isCorpCoupon: true,
            password: this.password
          };

          this.mode = 'indeterminate';
          let url = 'billingservice/usersubscription/payment';
          this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
            (response) => {
              this.payData = response;
              if (response?.status === true) {
                this.globalServices?.postUserActivityLog({
                  paymentCompleted: true,
                });
                let localStorageObj = JSON.parse(
                  localStorage.getItem('userActivityLog')
                );
                localStorage.setItem(
                  'userActivityLog',
                  JSON.stringify({
                    ...localStorageObj,
                    ...{ paymentCompleted: true },
                  })
                );
                this.showThirdStep = false;
                this.newMiddleSection = false;
                if (response && response.paymentDeducted) {
                  this.showAlert = true;
                  this.responseMessage = 'Payment Successfull!';
                }
                localStorage.removeItem('planpayment');
                this.globalServices.isActivePlan = 1; // for user buy the plan so remove flag from Header component using global service !!
                localStorage?.setItem('isActivePlan', '1');
                setTimeout(() => {
                  this.mode = 'determinate';
                  if (localStorage.getItem('corporateCoupon') ? localStorage.getItem('corporateCoupon') == 'MLWOLA' : '') {
                    window.location.href = "https://healthvio.bexcodeservices.com/thank-you"
                  } else {
                    this.router.navigate(['/confirmation']);
                  }
                }, 0);
              } else {
                this.subscriberdata = JSON.parse(
                  localStorage.getItem('planpayment')
                );
                localStorage.setItem('userActivityLog', JSON.stringify({ "loginFromUrl": "free", "questionaireCompleted": false }));
                this.GettotalPrice();
                this.findDiscountPrice();
                this.showAlert = true;
                this.responseMessage =
                  'Sorry, we could not complete the transaction. Please try again later!';
                this.mode = 'determinate';
                setTimeout(() => {
                  window.location.reload();
                }, 2000)
              }
            },
            (err) => {
              this.mode = 'determinate';
              this.errorMessage = 'Something went wrong!';
              setTimeout(() => {
                this.errorMessage = '';
              }, 3000);
            }
          );
        } else {
          this.showAlert = true;
          this.responseMessage = 'Something went wrong!';
        }
      } catch (error) {
        this.mode = 'determinate';
        this.showAlert = true;
        this.responseMessage = 'Something went wrong! Please try again.';
      }
    }
  }

  backToPlanSection() {
    if (this.globalServices.isBrowser) {
      this.globalServices?.postUserActivityLog({ planSelectionCompleted: '' });
      let localStorageObj = JSON.parse(localStorage.getItem('userActivityLog'));
      delete localStorageObj.planSelectionCompleted;
      localStorage.setItem('userActivityLog', JSON.stringify(localStorageObj));
      this.showThirdStep = false;
      this.newMiddleSection = true;
      this.removeCode('');
    }
  }

  openHollywoodLogin(){
    window.open('https://hollywoodfl.virtuagym.com/','_blank')
  }

}
